webpackJsonp([1],{

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chart_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_config__ = __webpack_require__(35);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        filters: {
            type: Object
        },
        views: {
            type: Object
        },
        series: {
            type: Array
        }
    },
    data: function data() {
        return {
            lineChart: null,
            uniqueCategories: [],
            uniqueCategoryValues: {},
            hasChartData: true,
            leftLabel: ''
        };
    },

    watch: {
        filters: {
            handler: function handler() {
                this.updateChart();
            },

            deep: true
        },
        views: {
            handler: function handler() {
                this.updateChart();
            },

            deep: true
        },
        series: function series() {
            this.updateChart();
        },
        chartData: function chartData() {
            this.updateChart();
        }
    },
    computed: {
        chartData: function chartData() {
            return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.chartData;
        }
    },
    methods: {
        calculate: function calculate() {
            var _this = this;

            var tempData = {};
            var seriesData = {};

            this.uniqueCategories = [];
            this.uniqueCategoryValues = {};

            // clone array. not robust. methods and Infinity will be stripped
            var filteredData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.chartData.data));

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).length) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).forEach(function (filterCategory) {
                    var filterValue = _this.filters[filterCategory];

                    if (filterValue) {
                        filteredData = filteredData.filter(function (datum) {
                            return datum.categories[filterCategory] === filterValue;
                        });
                    }
                });
            }

            filteredData.forEach(function (datum, filteredIndex) {
                var date = datum.categories.Date;

                if (_this.views.dateGroup === 'Weeks') {
                    filteredData[filteredIndex].categories.Date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('W YYYY');
                } else if (_this.views.dateGroup === 'Months') {
                    filteredData[filteredIndex].categories.Date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('MMMM YYYY');
                }

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datum.categories).forEach(function (category) {
                    if (!_this.uniqueCategories.includes(category)) {
                        _this.uniqueCategories.push(category);
                    }

                    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.uniqueCategoryValues).includes(category)) {
                        _this.uniqueCategoryValues[category] = [datum.categories[category]];
                        // eslint-disable-next-line
                    } else if (!_this.uniqueCategoryValues[category].includes(datum.categories[category])) {
                        _this.uniqueCategoryValues[category].push(datum.categories[category]);
                    }
                });
            });

            this.uniqueCategoryValues[this.views.XValue].forEach(function (d) {
                tempData[d] = {};
                _this.series.forEach(function (s) {
                    tempData[d][s] = 0;
                });
            });

            var uniqueValueNames = [];

            filteredData.forEach(function (datum) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datum.values).forEach(function (v) {
                    var keyName = datum.categories[_this.views.XValue];

                    tempData[keyName][v] += datum.values[v];

                    if (!uniqueValueNames.includes(v)) {
                        uniqueValueNames.push(v);
                    }
                });
            });

            uniqueValueNames.push('CTR %');

            uniqueValueNames.forEach(function (v) {
                seriesData[v] = [];

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tempData).forEach(function (date) {
                    var tempDatum = tempData[date];
                    var y = v === 'CTR %' ? tempDatum.Clicks / tempDatum.Impressions * 100 : tempDatum[v];

                    seriesData[v].push({
                        x: date,
                        y: y
                    });
                });
            });

            return seriesData;
        },
        updateChart: function updateChart() {
            var _this2 = this;

            if (this.views.XValue === null) {
                return;
            }

            this.createChart();

            var plotData = this.calculate();

            var availableSeries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(plotData);
            // Remove all datasets
            this.lineChart.data.datasets = [];

            var chartData = {};

            if (this.views.Series) {
                this.leftLabel = this.views.Series;
            }

            this.lineChart.options.scales.yAxes[0].scaleLabel.labelString = this.views.Series === null ? 'Impressions/Clicks' : this.leftLabel;

            if (this.views.Series !== null) {
                this.lineChart.options.scales.yAxes[1].display = false;
            } else {
                this.lineChart.options.scales.yAxes[1].display = true;
            }

            availableSeries.forEach(function (s) {
                chartData[s] = {
                    label: s,
                    data: plotData[s],
                    fill: 'origin',
                    borderColor: __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */][s].line,
                    lineTension: 0.1,
                    pointRadius: 0,
                    pointHitRadius: 15,
                    tooltips: {
                        backgroundColor: __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */][s].backgroundColor
                    },
                    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */][s].backgroundColor,
                    yAxisID: s === 'CTR %' ? 'yRight' : 'yLeft',
                    pointHoverBackgroundColor: __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */][s].line,
                    pointHoverBorderColor: __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */][s].line
                };

                if (_this2.views.XValue !== 'Date') {
                    chartData[s].backgroundColor = __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */][s].backgroundColor;
                }
            });

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(plotData).forEach(function (s) {
                if (!_this2.views.Series) {
                    _this2.lineChart.data.datasets.push(chartData[s]);
                } else if (_this2.views.Series && s === _this2.views.Series) {
                    _this2.lineChart.data.datasets.push(chartData[s]);
                }
            });

            this.lineChart.data.datasets.reverse();

            if (this.views.XValue !== 'Date' || this.views.dateGroup !== 'Days') {
                var xAxes = this.lineChart.options.scales.xAxes[0];
                xAxes.type = 'category';
                xAxes.labels = this.uniqueCategoryValues[this.views.XValue];
            } else {
                var _xAxes = this.lineChart.options.scales.xAxes[0];
                _xAxes.type = 'time';
                delete _xAxes.labels;
            }

            this.lineChart.update();
        },
        createChart: function createChart() {
            if (this.lineChart) {
                this.lineChart.destroy();
                this.lineChart = null;
            }

            if (this.views.Series) {
                this.leftLabel = this.views.Series;
            }

            var options = {
                legend: {
                    position: 'bottom'
                },
                scales: {
                    xAxes: [{
                        type: this.views.XValue === 'Date' ? 'time' : 'category',
                        distribution: 'linear'
                    }],
                    yAxes: [{
                        id: 'yLeft',
                        stacked: false,
                        ticks: {
                            callback: function callback(value) {
                                return value.toLocaleString('en-GB', { useGrouping: true });
                            }
                        },
                        scaleLabel: {
                            display: true,
                            labelString: this.leftLabel === null ? 'Impressions/Clicks' : this.leftLabel
                        }
                    }, {
                        id: 'yRight',
                        stacked: false,
                        ticks: {
                            callback: function callback(value) {
                                return value.toLocaleString('en-GB', { maximumFractionDigits: 2 });
                            }
                        },
                        position: 'right',
                        scaleLabel: {
                            display: true,
                            labelString: 'CTR %'
                        }
                    }]
                },
                tooltips: {
                    cornerRadius: 0,
                    displayColors: true,
                    mode: 'index',
                    position: 'nearest',
                    intersect: true,
                    xPadding: 16,
                    yPadding: 16,
                    backgroundColor: '#ffffff',
                    borderColor: __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */].fonts.kpmgBlue,
                    borderWidth: 1,
                    titleFontColor: __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */].fonts.kpmgBlue,
                    bodyFontColor: __WEBPACK_IMPORTED_MODULE_5__util_config__["a" /* colors */].fonts.kpmgBlue,
                    bodySpacing: 4,
                    callbacks: {
                        label: function label(item, data) {
                            var label = data.datasets[item.datasetIndex].label;
                            var value = item.yLabel;

                            var format = {
                                useGrouping: true,
                                maximumFractionDigits: 2
                            };

                            if (value >= 1) {
                                format.maximumFractionDigits = 0;
                            }

                            var formattedValue = value.toLocaleString('en-GB', format);

                            return label + ': ' + formattedValue;
                        },
                        labelColor: function labelColor(tooltipItem, chart) {
                            var itemIndex = tooltipItem.datasetIndex;
                            var dataset = chart.config.data.datasets[itemIndex];

                            return {
                                borderColor: 'transparent',
                                backgroundColor: dataset.borderColor
                            };
                        }
                    }
                }
            };

            if (this.views.XValue === 'Date') {
                options.scales.xAxes[0].time = {
                    unit: 'day',
                    displayFormats: { day: 'DD MMM YYYY' },
                    parser: 'YYYY-MM-DD'
                };
            }

            var config = {
                type: this.views.XValue === 'Date' ? 'line' : 'bar',
                data: {
                    datasets: []
                },
                options: options
            };

            this.lineChart = new __WEBPACK_IMPORTED_MODULE_3_chart_js___default.a(this.$refs.lineCanvas, config);
        }
    },
    mounted: function mounted() {
        this.createChart();
        this.updateChart();
    }
});

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsrsasign__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsrsasign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsrsasign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_config__ = __webpack_require__(35);






var JWT_ITEM_NAME = 'jwt';
var USER_ID_ITEM_NAME = 'userId';
var LAST_LOGIN_ITEM_NAME = 'lastLogin';

/* harmony default export */ __webpack_exports__["a"] = ({
    // Send a request to the login URL and save the returned JWT
    login: function login(context, credentials, redirectRouteName) {
        var loginConfig = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setLoginNotAuth', false);
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setLoginFailed', false);

        context.$http.post(__WEBPACK_IMPORTED_MODULE_3__util_config__["b" /* urls */].AUTH_URL, credentials, loginConfig).then(function (response) {
            if (response.status === 200) {
                var token = response.body.access_token;
                var id = response.body.user_id;
                var lastLogin = response.body.last_login;

                window.localStorage.setItem(JWT_ITEM_NAME, token);
                window.localStorage.setItem(USER_ID_ITEM_NAME, id);
                window.localStorage.setItem(LAST_LOGIN_ITEM_NAME, lastLogin);

                // TODO: send url for last login update /lastloong/{userid}
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('login');
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setTimedOut', false);
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setLoggingIn', false);

                if (redirectRouteName) {
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
                        name: redirectRouteName
                    });
                }
            }
        }).catch(function (e) {
            if (e.status === 401) {
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setTimedOut', false);
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setLoggingIn', false);
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setLoginNotAuth', true);
            } else {
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setTimedOut', false);
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setLoggingIn', false);
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setLoginFailed', true);
            }
        });
    },


    // // To log out, we just need to remove the token
    logout: function logout() {
        localStorage.removeItem(JWT_ITEM_NAME);
        localStorage.removeItem(USER_ID_ITEM_NAME);
        localStorage.removeItem(LAST_LOGIN_ITEM_NAME);
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('logout');

        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
            name: 'Login'
        });
    },

    /**
     * @return Boolean
     * Return true if there is a token and it has a valid date.
     */
    checkAuth: function checkAuth() {
        var jwt = localStorage.getItem(JWT_ITEM_NAME);

        if (jwt) {
            var payloadObj = __WEBPACK_IMPORTED_MODULE_0_jsrsasign___default.a.jws.JWS.parse(jwt).payloadObj;
            var exp = payloadObj.exp;

            // exp time is seconds from epoch. Date takes milliseconds so convert
            var expiryDate = new Date(exp * 1000);

            if (expiryDate > new Date()) {
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('login');
                return true;
            }
        }

        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('logout');
        return false;
    },


    // // The object to be passed as a header for authenticated requests
    getAuthHeader: function getAuthHeader() {
        return {
            Authorization: 'JWT ' + localStorage.getItem(JWT_ITEM_NAME)
        };
    }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        filters: {
            type: Object
        },
        views: {
            type: Object
        },
        series: {
            type: Array
        }
    },
    data: function data() {
        return {
            tableData: []
        };
    },

    watch: {
        filters: {
            handler: function handler() {
                this.makeTable();
            },

            deep: true
        },
        views: {
            handler: function handler() {
                this.makeTable();
            },

            deep: true
        },
        series: function series() {
            this.makeTable();
        },
        chartData: function chartData() {
            this.makeTable();
        }
    },
    computed: {
        chartData: function chartData() {
            return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.chartData;
        }
    },
    methods: {
        makeTable: function makeTable() {
            var _this = this;

            if (this.views.XValue === null) {
                return;
            }

            // clone array. not robust. methods and Infinity will be stripped
            var filteredData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.chartData.data));

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).length) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).forEach(function (filterCategory) {
                    var filterValue = _this.filters[filterCategory];

                    if (filterValue) {
                        filteredData = filteredData.filter(function (datum) {
                            return datum.categories[filterCategory] === filterValue;
                        });
                    }
                });
            }

            // change dates to format selected
            filteredData.forEach(function (datum, filteredIndex) {
                if (_this.views.dateGroup === 'Weeks') {
                    filteredData[filteredIndex].categories.Date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(datum.categories.Date, 'YYYY-MM-DD').format('W YYYY');
                } else if (_this.views.dateGroup === 'Months') {
                    filteredData[filteredIndex].categories.Date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(datum.categories.Date, 'YYYY-MM-DD').format('MMMM YYYY');
                }
            });

            var sortedData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteredData));

            var tData = {};

            sortedData.forEach(function (d) {
                if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tData).includes(d.categories[_this.views.XValue])) {
                    var values = {};

                    _this.series.forEach(function (s) {
                        values[s] = d.values[s];
                    });

                    tData[d.categories[_this.views.XValue]] = {
                        values: values
                    };
                } else {
                    // [this.views.XValue] already on so add values
                    _this.series.forEach(function (s) {
                        tData[d.categories[_this.views.XValue]].values[s] += d.values[s];
                    });
                }
            });

            // Add CTRs
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tData).forEach(function (keyName) {
                var rowValues = tData[keyName].values;

                var ctr = rowValues.Clicks / rowValues.Impressions * 100;
                rowValues['CTR %'] = ctr.toLocaleString('en-GB', { maximumFractionDigits: 2 });
            });

            this.tableData = tData;
        }
    },
    mounted: function mounted() {
        this.makeTable();
    }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pageNumber: 1,
            direction: 'left',
            perPage: 10,
            tableData: {
                head: [],
                body: []
            },
            // bodyEl: null,
            tableHeight: 100
            // resizeDebounceTimer: null,
        };
    },

    computed: {
        pacingData: function pacingData() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.pacingData.data;
        },
        pacingDataExists: function pacingDataExists() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.pacingData.data.length;
        }
    },
    mounted: function mounted() {
        this.makeTable();

        // window.addEventListener('resize', () => {
        //     clearTimeout(this.resizeDebounceTimer);

        //     this.resizeDebounceTimer = setTimeout(() => {
        //     }, 200);
        // });
    },

    methods: {
        setTableHeight: function setTableHeight(el) {
            this.tableHeight = el.clientHeight + this.$refs.thead.clientHeight;
        },
        next: function next() {
            this.direction = 'left';
            this.pageNumber += 1;
        },
        previous: function previous() {
            this.direction = 'right';
            this.pageNumber -= 1;
        },
        slideName: function slideName() {
            return this.direction === 'right' ? 'slideRight' : 'slideLeft';
        },
        makeTable: function makeTable() {
            var _this = this;

            var uniques = {
                categories: [],
                values: []
            };

            this.pacingData.forEach(function (datum) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(datum.categories).forEach(function (keyName) {
                    if (!uniques.categories.includes(keyName)) {
                        uniques.categories.push(keyName);
                    }
                });

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(datum.values).forEach(function (keyName) {
                    if (!uniques.values.includes(keyName)) {
                        uniques.values.push(keyName);
                    }
                });
            });

            var tableHeadings = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(uniques.categories), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(uniques.values));

            var tableBody = [];

            var counter = 0;
            var page = [];

            this.pacingData.forEach(function (datum, index) {
                var row = {
                    categories: [],
                    values: []
                };

                uniques.categories.forEach(function (category) {
                    row.categories.push(datum.categories[category]);
                });

                uniques.values.forEach(function (value) {
                    row.values.push(datum.values[value]);
                });

                counter += 1;

                if (counter % _this.perPage === 0) {
                    page.push(row);
                    tableBody.push(page);
                    page = [];
                } else if (_this.pacingData.length === index + 1) {
                    page.push(row);
                    tableBody.push(page);
                } else {
                    page.push(row);
                }
            });

            this.tableData = {
                head: tableHeadings,
                body: tableBody
            };
        }
    }
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tiles_WebsiteTileContainer__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BigChartContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebsiteTable__ = __webpack_require__(520);
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        WebsiteTileContainer: __WEBPACK_IMPORTED_MODULE_1__components_tiles_WebsiteTileContainer__["a" /* default */],
        BigChartContainer: __WEBPACK_IMPORTED_MODULE_2__components_BigChartContainer__["a" /* default */],
        WebsiteTable: __WEBPACK_IMPORTED_MODULE_3__components_WebsiteTable__["a" /* default */]
    },
    computed: {
        tableData: function tableData() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.table;
        },
        refreshingCharts: function refreshingCharts() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.refreshStatusCharts;
        },
        refreshingPacing: function refreshingPacing() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.refreshStatusPacing;
        }
    }
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tiles_StatTile__ = __webpack_require__(88);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        StatTile: __WEBPACK_IMPORTED_MODULE_1__components_tiles_StatTile__["a" /* default */]
    },
    computed: {
        viewsTarget: function viewsTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.viewsTarget) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.viewsTarget;
            }

            return 0;
        },
        bounceRateTarget: function bounceRateTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.bounceRateTarget) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.bounceRateTarget;
            }

            return 0;
        },
        conversionsTarget: function conversionsTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.conversionsTarget) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.conversionsTarget;
            }

            return 0;
        },
        viewsPercent: function viewsPercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.viewsPercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.viewsPercent;
            }

            return 0;
        },
        averageTimePercent: function averageTimePercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.averageTimePercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.averageTimePercent;
            }

            return 0;
        },
        bounceRatePercent: function bounceRatePercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.bounceRatePercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.bounceRatePercent;
            }

            return 0;
        },
        conversionsPercent: function conversionsPercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.conversionsPercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.conversionsPercent;
            }

            return 0;
        },
        views: function views() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.views) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.views;
            }

            return 0;
        },
        bounceRate: function bounceRate() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.bounceRate) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.bounceRate;
            }

            return 0;
        },
        conversions: function conversions() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.conversions) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.conversions;
            }

            return 0;
        },
        averageTime: function averageTime() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.averageTime) {
                var time = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.averageTime;

                var hours = time.h;
                var minutes = time.m;
                var seconds = time.s;

                return {
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
            }

            return {
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        },
        averageTimeTarget: function averageTimeTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.averageTimeTarget) {
                var time = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.websiteData.tiles.averageTimeTarget;

                var hours = time.h;
                var minutes = time.m;
                var seconds = time.s;

                return {
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
            }

            return {
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }
    }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return urls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colors; });
var API_BASE = '%%API_BASE%%';
var AUTH_URL = API_BASE + 'auth';
var DCM_DATA_URL = API_BASE + 'api/getMediaData/'; // Media tiles and charts
var PACING_DATA_URL = API_BASE + 'api/getPacingData/'; // Media pacing table
var WEBSITE_ANALYTICS_URL = API_BASE + 'api/getAnalyticsData'; // Website tiles
var MEDIA_SOURCES_URL = API_BASE + 'api/getMediaSources/';
var NOTIFICATIONS_URL = API_BASE + 'api/getNotifications/';
var EXPORT_URL = API_BASE + 'api/export/';

// const ALL_SOURCES_PARAM = 'sources=all';

var urls = {
    API_BASE: API_BASE,
    AUTH_URL: AUTH_URL,
    DCM_DATA_URL: DCM_DATA_URL,
    PACING_DATA_URL: PACING_DATA_URL,
    WEBSITE_ANALYTICS_URL: WEBSITE_ANALYTICS_URL,
    MEDIA_SOURCES_URL: MEDIA_SOURCES_URL,
    NOTIFICATIONS_URL: NOTIFICATIONS_URL,
    EXPORT_URL: EXPORT_URL
};

var colors = {
    fonts: {
        kpmgBlue: '#00338d'
    },
    Clicks: {
        line: '#009a44',
        backgroundColor: 'transparent'
    },
    Impressions: {
        line: '#cecece',
        backgroundColor: '#a8a8a840' // #RRGGBBAA
    },
    'CTR %': {
        line: '#005eb8',
        backgroundColor: 'transparent'
    }
};



/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pageNumber: 1,
            direction: 'left',
            perPage: 10,
            tableData: {
                head: [],
                body: []
            },
            tableHeight: 100
        };
    },

    computed: {
        pacingData: function pacingData() {
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteData.table.length) {
                return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteData.table;
            }

            return [];
        },
        pacingDataExists: function pacingDataExists() {
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteData.table.length) {
                return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.websiteData.table.length;
            }

            return false;
        }
    },
    mounted: function mounted() {
        this.makeTable();
    },

    methods: {
        setTableHeight: function setTableHeight(el) {
            this.tableHeight = el.clientHeight + this.$refs.thead.clientHeight;
        },
        next: function next() {
            this.direction = 'left';
            this.pageNumber += 1;
        },
        previous: function previous() {
            this.direction = 'right';
            this.pageNumber -= 1;
        },
        slideName: function slideName() {
            return this.direction === 'right' ? 'slideRight' : 'slideLeft';
        },
        makeTable: function makeTable() {
            var _this = this;

            var uniques = {
                categories: [],
                values: []
            };

            this.pacingData.forEach(function (datum) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(datum.categories).forEach(function (keyName) {
                    if (!uniques.categories.includes(keyName)) {
                        uniques.categories.push(keyName);
                    }
                });

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(datum.values).forEach(function (keyName) {
                    if (!uniques.values.includes(keyName)) {
                        uniques.values.push(keyName);
                    }
                });
            });

            var tableHeadings = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(uniques.categories), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(uniques.values));

            var tableBody = [];

            var counter = 0;
            var page = [];

            this.pacingData.forEach(function (datum, index) {
                var row = {
                    categories: [],
                    values: []
                };

                uniques.categories.forEach(function (category) {
                    row.categories.push(datum.categories[category]);
                });

                uniques.values.forEach(function (value) {
                    row.values.push(datum.values[value]);
                });

                counter += 1;

                if (counter % _this.perPage === 0) {
                    page.push(row);
                    tableBody.push(page);
                    page = [];
                } else if (_this.pacingData.length === index + 1) {
                    page.push(row);
                    tableBody.push(page);
                } else {
                    page.push(row);
                }
            });

            this.tableData = {
                head: tableHeadings,
                body: tableBody
            };
        }
    }
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        notifications: function notifications() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.notificationsData.notifications;
        }
    },
    methods: {
        closeNotifications: function closeNotifications() {
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('closeNotifications');
        }
    }
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_auth__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            username: null,
            password: null
        };
    },

    computed: {
        timedOut: function timedOut() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.timedOut;
        },
        notAuth: function notAuth() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.loginNotAuth;
        },
        loginFailed: function loginFailed() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.loginFailed;
        },
        loggingIn: function loggingIn() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.loggingIn;
        }
    },
    methods: {
        submit: function submit() {
            var username = this.username;
            var password = this.password;
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setLoggingIn', true);

            __WEBPACK_IMPORTED_MODULE_0__util_auth__["a" /* default */].login(this, {
                username: username,
                password: password
            }, 'Home');
        }
    }
});

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        refreshing: function refreshing() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.refreshStatus;
        }
    },
    methods: {
        refresh: function refresh() {
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('refreshData');
        }
    }
});

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(356);
module.exports = __webpack_require__(357);


/***/ }),

/***/ 356:
/***/ (function(module, exports) {

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
/* eslint-disable */
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function value(searchElement, fromIndex) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            var len = o.length >>> 0;

            if (len === 0) {
                return false;
            }

            var n = fromIndex | 0;

            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
            }

            while (k < len) {
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }

                k++;
            }

            return false;
        }
    });
}

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (this.length > targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
        }
    };
}

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuebar__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(50);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuebar___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

function watchForHover() {
    var hasHoverClass = false;
    var container = document.body;
    var lastTouchTime = 0;

    function enableHover() {
        // filter emulated events coming from touch events
        if (new Date() - lastTouchTime < 500) return;
        if (hasHoverClass) return;

        container.className += ' has-hover';
        hasHoverClass = true;
    }

    function disableHover() {
        if (!hasHoverClass) return;

        container.className = container.className.replace(' has-hover', '');
        hasHoverClass = false;
    }

    function updateLastTouchTime() {
        lastTouchTime = new Date();
    }

    document.addEventListener('touchstart', updateLastTouchTime, true);
    document.addEventListener('touchstart', disableHover, true);
    document.addEventListener('mousemove', enableHover, true);

    enableHover();
}

watchForHover();

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31cecb54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(539);
function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31cecb54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavHeader_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69611b67_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavHeader_vue__ = __webpack_require__(535);
function injectStyle (ssrContext) {
  __webpack_require__(368)
  __webpack_require__(369)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69611b67"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69611b67_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f876ac6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(528);
function injectStyle (ssrContext) {
  __webpack_require__(400)
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f876ac6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f876ac6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiltersContainer_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0712e218_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiltersContainer_vue__ = __webpack_require__(432);
function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0712e218"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiltersContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0712e218_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiltersContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateInput_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88b2e5d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateInput_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88b2e5d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{class:{ open: _vm.open },attrs:{"calendar-class":"calendar","wrapper-class":"datepicker","input-class":"input","placeholder":_vm.placeholder,"clear-button":true,"calendar-button":true,"monday-first":true,"disabled":_vm.disabled,"value":_vm.val,"name":_vm.inputId,"id":_vm.inputId},on:{"input":function($event){_vm.inputUpdate($event)},"opened":_vm.opened,"closed":_vm.closed}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Select__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_index__ = __webpack_require__(430);
/* unused harmony reexport VueSelect */
/* unused harmony reexport mixins */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_Select__["a" /* default */]);


/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7344e6c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__ = __webpack_require__(429);
function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7344e6c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 411:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown v-select",class:_vm.dropdownClasses,attrs:{"dir":_vm.dir}},[_c('div',{ref:"toggle",class:['dropdown-toggle', 'clearfix'],on:{"mousedown":function($event){$event.preventDefault();_vm.toggleDropdown($event)}}},[_c('transition',{attrs:{"name":"tagAppear"}},_vm._l((_vm.valueAsArray),function(option){return _c('span',{key:option.index,staticClass:"selected-tag"},[_vm._t("selected-option",[_vm._v("\n        "+_vm._s(_vm.getOptionLabel(option))+"\n      ")],null,option),_vm._v(" "),(_vm.multiple)?_c('button',{staticClass:"close",attrs:{"disabled":_vm.disabled,"type":"button","aria-label":"Remove option"},on:{"click":function($event){_vm.deselect(option)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]):_vm._e()],2)})),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],ref:"search",staticClass:"form-control",style:({ width: _vm.isValueEmpty ? '100%' : 'auto' }),attrs:{"type":"search","autocomplete":"false","disabled":_vm.disabled,"placeholder":_vm.searchPlaceholder,"tabindex":_vm.tabindex,"readonly":!_vm.searchable,"id":_vm.inputId,"aria-label":"Search for option"},domProps:{"value":(_vm.search)},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.maybeDeleteValue($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.typeAheadUp($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.typeAheadDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.typeAheadSelect($event)}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.onEscape($event)},"blur":_vm.onSearchBlur,"focus":_vm.onSearchFocus,"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showClearButton),expression:"showClearButton"}],staticClass:"clear",attrs:{"disabled":_vm.disabled,"type":"button","title":"Clear selection"},on:{"click":_vm.clearSelection}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),(!_vm.noDrop)?_c('i',{ref:"openIndicator",staticClass:"open-indicator",attrs:{"role":"presentation"}}):_vm._e(),_vm._v(" "),_vm._t("spinner",[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mutableLoading),expression:"mutableLoading"}],staticClass:"spinner"},[_vm._v("Loading...")])])],2),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[(_vm.dropdownOpen)?_c('ul',{ref:"dropdownMenu",staticClass:"dropdown-menu",style:({ 'max-height': _vm.maxHeight })},[_vm._l((_vm.filteredOptions),function(option,index){return _c('li',{key:index,class:{ active: _vm.isOptionSelected(option), highlight: index === _vm.typeAheadPointer },on:{"mouseover":function($event){_vm.typeAheadPointer = index}}},[_c('a',{on:{"mousedown":function($event){$event.preventDefault();_vm.select(option)}}},[_vm._t("option",[_vm._v("\n          "+_vm._s(_vm.getOptionLabel(option))+"\n        ")],null,option)],2)])}),_vm._v(" "),(!_vm.filteredOptions.length)?_c('li',{staticClass:"no-options"},[_vm._t("no-options",[_vm._v("Sorry, no matching options.")])],2):_vm._e()],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typeAheadPointer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typeAheadPointer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__typeAheadPointer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pointerScroll__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pointerScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pointerScroll__);
/* eslint-disable */




/* unused harmony default export */ var _unused_webpack_default_export = ({ ajax: __WEBPACK_IMPORTED_MODULE_0__ajax___default.a, pointer: __WEBPACK_IMPORTED_MODULE_1__typeAheadPointer___default.a, pointerScroll: __WEBPACK_IMPORTED_MODULE_2__pointerScroll___default.a });

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('selector',{staticClass:"custom-select",class:[ _vm.selected ? 'selected' : '', _vm.passThroughClass ? _vm.passThroughClass : ''  ],attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"max-height":"asdf","transition":"expand","options":_vm.options,"searchable":_vm.searchable,"inputId":_vm.inputId,"disabled":_vm.disabled},on:{"input":function($event){_vm.inputUpdate($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('div',{staticClass:"d-md-none filter-open",class:{ 'is-open': _vm.filterOpen },on:{"click":_vm.toggleFilterOpen}},[_vm._v("\n        FILTER VIEW "),_c('div',{staticClass:"icon icon--inline icon--arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"max-container filters-wrapper",class:{ 'is-open': _vm.filterOpen }},[_c('div',{staticClass:"d-md-flex"},[_c('select-input',{staticClass:"source-filter filter",attrs:{"placeholder":"Media Sources","options":_vm.mediaSources,"value":_vm.globalSource,"searchable":false,"inputId":"source"},on:{"input":_vm.updateSource}}),_vm._v(" "),_c('div',{staticClass:"date-filters"},[_c('date-input',{staticClass:"filter",attrs:{"placeholder":"Select from date","disabled":_vm.fromDisabled(),"val":_vm.fromDate,"inputId":"fromDate"},on:{"input":_vm.updateFromDate}}),_vm._v(" "),_c('date-input',{staticClass:"filter",attrs:{"placeholder":"Select to date","disabled":_vm.toDisabled(),"val":_vm.toDate,"inputId":"toDate"},on:{"input":_vm.updateToDate}})],1),_vm._v(" "),_c('select-input',{staticClass:"platform-filter d-md-none",attrs:{"placeholder":"Choose Platform","options":_vm.tabChoices,"value":_vm.currentTabFormatted,"searchable":false,"inputId":"tab"},on:{"input":_vm.updateCurrentTab}}),_vm._v(" "),_c('div',{staticClass:"reset-buttons"},[_c('button',{staticClass:"reset-button",on:{"click":_vm.reset}},[_vm._v("Reset")])])],1)]),_vm._v(" "),_c('div',{staticClass:"max-container d-none d-md-block"},[_c('div',{staticClass:"d-md-flex"},[_c('div',{staticClass:"tab font-arial text-center",class:{ active: _vm.currentTab === 'media' },on:{"click":function($event){_vm.updateCurrentTab('media')}}},[_vm._v("Media")]),_vm._v(" "),_c('div',{staticClass:"tab font-arial text-center",class:{ active: _vm.currentTab === 'website' },on:{"click":function($event){_vm.updateCurrentTab('website')}}},[_vm._v("Website")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabContainer_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_336e8186_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabContainer_vue__ = __webpack_require__(524);
function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-336e8186"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_336e8186_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_config__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_auth__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["a"] = ({
    export: function _export(context, _ref) {
        var format = _ref.format,
            type = _ref.type;

        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                format: format,
                type: type
            }, __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.globalFilters, __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.chartFilters, __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.chartViews, { currentTab: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.currentTab });

            var config = {
                headers: __WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].getAuthHeader(),
                responseType: 'arraybuffer',
                params: params
            };
            console.log(params);
            var getUrl = '' + __WEBPACK_IMPORTED_MODULE_2__util_config__["b" /* urls */].EXPORT_URL;

            context.$http.get(getUrl, config).then(function (res) {
                var blob = new Blob([res.data], { type: res.headers.get('content-type') });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'KPMG Reporting';
                link.click();
                resolve();
            });
        });
    }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaContainer_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3cc769_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaContainer_vue__ = __webpack_require__(514);
function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e3cc769"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3cc769_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 440:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaTileContainer_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658332ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaTileContainer_vue__ = __webpack_require__(446);
function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-658332ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaTileContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658332ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaTileContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 442:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"appear":"","name":"fade","mode":"out-in"}},[_c('div',{staticClass:"stat-tile"},[(_vm.icon)?_c('div',{staticClass:"d-none d-md-block icon",class:("icon--" + _vm.icon)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text font-arial",class:{ 'big-mg': !_vm.icon }},[_c('span',{staticClass:"d-md-none",domProps:{"innerHTML":_vm._s(_vm.mobileText)}}),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline",domProps:{"innerHTML":_vm._s(_vm.text)}})]),_vm._v(" "),(_vm.time)?_c('div',{staticClass:"number",class:[ _vm.secondNumber ? 'big-mg': '', _vm.color ? ("number--" + _vm.color) : '' ]},[_vm._v("\n                "+_vm._s(_vm.animatedHour)+":"+_vm._s(_vm.animatedMinutes)+":"+_vm._s(_vm.animatedSeconds)+"\n            ")]):(_vm.percentage)?_c('div',{staticClass:"number",class:[ _vm.secondNumber ? 'big-mg': '', _vm.color ? ("number--" + _vm.color) : '' ]},[_vm._v("\n                "+_vm._s(_vm.animatedNumber)+"%\n            ")]):_c('div',{staticClass:"number",class:[ _vm.secondNumber ? 'big-mg': '', _vm.color ? ("number--" + _vm.color) : '' ]},[_vm._v("\n                "+_vm._s(_vm.animatedNumber)+"\n            ")]),_vm._v(" "),(_vm.secondNumber || _vm.secondNumber === 0)?_c('div',{staticClass:"d-none d-md-inline second-number",class:[ _vm.color ? ("number--" + _vm.color) : '' ]},[_vm._v("\n                ("+_vm._s(_vm.animatedSecondNumber)+")\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"percent-bar",class:[ _vm.color ? ("percent-bar--" + _vm.color) : '' ]},[(_vm.time)?_c('span',{staticClass:"percent font-arial"},[_vm._v(_vm._s(_vm.animatedPercent)+"% (Target: "+_vm._s(_vm.targetHours)+":"+_vm._s(_vm.targetMinutes)+":"+_vm._s(_vm.targetSeconds)+")")]):(_vm.percentage)?_c('span',{staticClass:"percent font-arial"},[_vm._v(_vm._s(_vm.animatedPercent)+"% (Target: "+_vm._s(_vm.targetFormatted)+"%)")]):_c('span',{staticClass:"percent font-arial"},[_vm._v(_vm._s(_vm.animatedPercent)+"% (Target: "+_vm._s(_vm.targetFormatted)+")")]),_vm._v(" "),_c('div',{staticClass:"fill",class:[ _vm.color ? ("fill--" + _vm.color) : '' ],style:({ width: (_vm.animatedWidth + "%") })})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile-container"},[_c('div',{staticClass:"max-container"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"tile-wrapper col-6 col-md-3"},[_c('stat-tile',{staticClass:"tile",attrs:{"mobileText":"Impressions served","text":"Ad impressions<br>served","number":_vm.totalImpressions,"icon":"ads-served","percent":_vm.totalImpressionsPercent,"target":_vm.totalImpressionsTarget,"flip":true,"color":"green"}})],1),_vm._v(" "),_c('div',{staticClass:"tile-wrapper col-6 col-md-3"},[_c('stat-tile',{staticClass:"tile",attrs:{"mobileText":"CTR (No. of clicks)","text":"Click-through rate<br>(Number of adverts clicked)","number":_vm.totalCTR,"secondNumber":_vm.totalClicks,"percent":_vm.totalCTRPercent,"target":_vm.totalCTRTarget,"flip":true,"percentage":true,"color":"blue"}})],1),_vm._v(" "),_c('div',{staticClass:"tile-wrapper col-6 col-md-3"},[_c('stat-tile',{staticClass:"tile",attrs:{"mobileText":"Visits to LP","text":"Visits to<br>campaign landing page","number":_vm.totalVisits,"icon":"monitor","percent":_vm.totalVisitsPercent,"target":_vm.totalVisitsTarget,"flip":true,"color":"teal"}})],1),_vm._v(" "),_c('div',{staticClass:"tile-wrapper col-6 col-md-3"},[_c('stat-tile',{staticClass:"tile",attrs:{"mobileText":"Average time on site","text":"Average time<br>spend on site","time":_vm.averageTime,"icon":"clock","percent":_vm.averageTimePercent,"target":_vm.averageTimeTarget,"flip":true,"color":"pink"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleChartContainer_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17cb67c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleChartContainer_vue__ = __webpack_require__(505);
function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a17cb67c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleChartContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17cb67c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleChartContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 94,
	"./af.js": 94,
	"./ar": 95,
	"./ar-dz": 96,
	"./ar-dz.js": 96,
	"./ar-kw": 97,
	"./ar-kw.js": 97,
	"./ar-ly": 98,
	"./ar-ly.js": 98,
	"./ar-ma": 99,
	"./ar-ma.js": 99,
	"./ar-sa": 100,
	"./ar-sa.js": 100,
	"./ar-tn": 101,
	"./ar-tn.js": 101,
	"./ar.js": 95,
	"./az": 102,
	"./az.js": 102,
	"./be": 103,
	"./be.js": 103,
	"./bg": 104,
	"./bg.js": 104,
	"./bm": 105,
	"./bm.js": 105,
	"./bn": 106,
	"./bn.js": 106,
	"./bo": 107,
	"./bo.js": 107,
	"./br": 108,
	"./br.js": 108,
	"./bs": 109,
	"./bs.js": 109,
	"./ca": 110,
	"./ca.js": 110,
	"./cs": 111,
	"./cs.js": 111,
	"./cv": 112,
	"./cv.js": 112,
	"./cy": 113,
	"./cy.js": 113,
	"./da": 114,
	"./da.js": 114,
	"./de": 115,
	"./de-at": 116,
	"./de-at.js": 116,
	"./de-ch": 117,
	"./de-ch.js": 117,
	"./de.js": 115,
	"./dv": 118,
	"./dv.js": 118,
	"./el": 119,
	"./el.js": 119,
	"./en-au": 120,
	"./en-au.js": 120,
	"./en-ca": 121,
	"./en-ca.js": 121,
	"./en-gb": 122,
	"./en-gb.js": 122,
	"./en-ie": 123,
	"./en-ie.js": 123,
	"./en-il": 124,
	"./en-il.js": 124,
	"./en-nz": 125,
	"./en-nz.js": 125,
	"./eo": 126,
	"./eo.js": 126,
	"./es": 127,
	"./es-do": 128,
	"./es-do.js": 128,
	"./es-us": 129,
	"./es-us.js": 129,
	"./es.js": 127,
	"./et": 130,
	"./et.js": 130,
	"./eu": 131,
	"./eu.js": 131,
	"./fa": 132,
	"./fa.js": 132,
	"./fi": 133,
	"./fi.js": 133,
	"./fo": 134,
	"./fo.js": 134,
	"./fr": 135,
	"./fr-ca": 136,
	"./fr-ca.js": 136,
	"./fr-ch": 137,
	"./fr-ch.js": 137,
	"./fr.js": 135,
	"./fy": 138,
	"./fy.js": 138,
	"./gd": 139,
	"./gd.js": 139,
	"./gl": 140,
	"./gl.js": 140,
	"./gom-latn": 141,
	"./gom-latn.js": 141,
	"./gu": 142,
	"./gu.js": 142,
	"./he": 143,
	"./he.js": 143,
	"./hi": 144,
	"./hi.js": 144,
	"./hr": 145,
	"./hr.js": 145,
	"./hu": 146,
	"./hu.js": 146,
	"./hy-am": 147,
	"./hy-am.js": 147,
	"./id": 148,
	"./id.js": 148,
	"./is": 149,
	"./is.js": 149,
	"./it": 150,
	"./it.js": 150,
	"./ja": 151,
	"./ja.js": 151,
	"./jv": 152,
	"./jv.js": 152,
	"./ka": 153,
	"./ka.js": 153,
	"./kk": 154,
	"./kk.js": 154,
	"./km": 155,
	"./km.js": 155,
	"./kn": 156,
	"./kn.js": 156,
	"./ko": 157,
	"./ko.js": 157,
	"./ky": 158,
	"./ky.js": 158,
	"./lb": 159,
	"./lb.js": 159,
	"./lo": 160,
	"./lo.js": 160,
	"./lt": 161,
	"./lt.js": 161,
	"./lv": 162,
	"./lv.js": 162,
	"./me": 163,
	"./me.js": 163,
	"./mi": 164,
	"./mi.js": 164,
	"./mk": 165,
	"./mk.js": 165,
	"./ml": 166,
	"./ml.js": 166,
	"./mn": 167,
	"./mn.js": 167,
	"./mr": 168,
	"./mr.js": 168,
	"./ms": 169,
	"./ms-my": 170,
	"./ms-my.js": 170,
	"./ms.js": 169,
	"./mt": 171,
	"./mt.js": 171,
	"./my": 172,
	"./my.js": 172,
	"./nb": 173,
	"./nb.js": 173,
	"./ne": 174,
	"./ne.js": 174,
	"./nl": 175,
	"./nl-be": 176,
	"./nl-be.js": 176,
	"./nl.js": 175,
	"./nn": 177,
	"./nn.js": 177,
	"./pa-in": 178,
	"./pa-in.js": 178,
	"./pl": 179,
	"./pl.js": 179,
	"./pt": 180,
	"./pt-br": 181,
	"./pt-br.js": 181,
	"./pt.js": 180,
	"./ro": 182,
	"./ro.js": 182,
	"./ru": 183,
	"./ru.js": 183,
	"./sd": 184,
	"./sd.js": 184,
	"./se": 185,
	"./se.js": 185,
	"./si": 186,
	"./si.js": 186,
	"./sk": 187,
	"./sk.js": 187,
	"./sl": 188,
	"./sl.js": 188,
	"./sq": 189,
	"./sq.js": 189,
	"./sr": 190,
	"./sr-cyrl": 191,
	"./sr-cyrl.js": 191,
	"./sr.js": 190,
	"./ss": 192,
	"./ss.js": 192,
	"./sv": 193,
	"./sv.js": 193,
	"./sw": 194,
	"./sw.js": 194,
	"./ta": 195,
	"./ta.js": 195,
	"./te": 196,
	"./te.js": 196,
	"./tet": 197,
	"./tet.js": 197,
	"./tg": 198,
	"./tg.js": 198,
	"./th": 199,
	"./th.js": 199,
	"./tl-ph": 200,
	"./tl-ph.js": 200,
	"./tlh": 201,
	"./tlh.js": 201,
	"./tr": 202,
	"./tr.js": 202,
	"./tzl": 203,
	"./tzl.js": 203,
	"./tzm": 204,
	"./tzm-latn": 205,
	"./tzm-latn.js": 205,
	"./tzm.js": 204,
	"./ug-cn": 206,
	"./ug-cn.js": 206,
	"./uk": 207,
	"./uk.js": 207,
	"./ur": 208,
	"./ur.js": 208,
	"./uz": 209,
	"./uz-latn": 210,
	"./uz-latn.js": 210,
	"./uz.js": 209,
	"./vi": 211,
	"./vi.js": 211,
	"./x-pseudo": 212,
	"./x-pseudo.js": 212,
	"./yo": 213,
	"./yo.js": 213,
	"./zh-cn": 214,
	"./zh-cn.js": 214,
	"./zh-hk": 215,
	"./zh-hk.js": 215,
	"./zh-tw": 216,
	"./zh-tw.js": 216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2521e66c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__ = __webpack_require__(501);
function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2521e66c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2521e66c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 452:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 223,
	"./af.js": 223,
	"./ar": 224,
	"./ar-dz": 225,
	"./ar-dz.js": 225,
	"./ar-kw": 226,
	"./ar-kw.js": 226,
	"./ar-ly": 227,
	"./ar-ly.js": 227,
	"./ar-ma": 228,
	"./ar-ma.js": 228,
	"./ar-sa": 229,
	"./ar-sa.js": 229,
	"./ar-tn": 230,
	"./ar-tn.js": 230,
	"./ar.js": 224,
	"./az": 231,
	"./az.js": 231,
	"./be": 232,
	"./be.js": 232,
	"./bg": 233,
	"./bg.js": 233,
	"./bm": 234,
	"./bm.js": 234,
	"./bn": 235,
	"./bn.js": 235,
	"./bo": 236,
	"./bo.js": 236,
	"./br": 237,
	"./br.js": 237,
	"./bs": 238,
	"./bs.js": 238,
	"./ca": 239,
	"./ca.js": 239,
	"./cs": 240,
	"./cs.js": 240,
	"./cv": 241,
	"./cv.js": 241,
	"./cy": 242,
	"./cy.js": 242,
	"./da": 243,
	"./da.js": 243,
	"./de": 244,
	"./de-at": 245,
	"./de-at.js": 245,
	"./de-ch": 246,
	"./de-ch.js": 246,
	"./de.js": 244,
	"./dv": 247,
	"./dv.js": 247,
	"./el": 248,
	"./el.js": 248,
	"./en-au": 249,
	"./en-au.js": 249,
	"./en-ca": 250,
	"./en-ca.js": 250,
	"./en-gb": 251,
	"./en-gb.js": 251,
	"./en-ie": 252,
	"./en-ie.js": 252,
	"./en-il": 253,
	"./en-il.js": 253,
	"./en-nz": 254,
	"./en-nz.js": 254,
	"./eo": 255,
	"./eo.js": 255,
	"./es": 256,
	"./es-do": 257,
	"./es-do.js": 257,
	"./es-us": 258,
	"./es-us.js": 258,
	"./es.js": 256,
	"./et": 259,
	"./et.js": 259,
	"./eu": 260,
	"./eu.js": 260,
	"./fa": 261,
	"./fa.js": 261,
	"./fi": 262,
	"./fi.js": 262,
	"./fo": 263,
	"./fo.js": 263,
	"./fr": 264,
	"./fr-ca": 265,
	"./fr-ca.js": 265,
	"./fr-ch": 266,
	"./fr-ch.js": 266,
	"./fr.js": 264,
	"./fy": 267,
	"./fy.js": 267,
	"./gd": 268,
	"./gd.js": 268,
	"./gl": 269,
	"./gl.js": 269,
	"./gom-latn": 270,
	"./gom-latn.js": 270,
	"./gu": 271,
	"./gu.js": 271,
	"./he": 272,
	"./he.js": 272,
	"./hi": 273,
	"./hi.js": 273,
	"./hr": 274,
	"./hr.js": 274,
	"./hu": 275,
	"./hu.js": 275,
	"./hy-am": 276,
	"./hy-am.js": 276,
	"./id": 277,
	"./id.js": 277,
	"./is": 278,
	"./is.js": 278,
	"./it": 279,
	"./it.js": 279,
	"./ja": 280,
	"./ja.js": 280,
	"./jv": 281,
	"./jv.js": 281,
	"./ka": 282,
	"./ka.js": 282,
	"./kk": 283,
	"./kk.js": 283,
	"./km": 284,
	"./km.js": 284,
	"./kn": 285,
	"./kn.js": 285,
	"./ko": 286,
	"./ko.js": 286,
	"./ky": 287,
	"./ky.js": 287,
	"./lb": 288,
	"./lb.js": 288,
	"./lo": 289,
	"./lo.js": 289,
	"./lt": 290,
	"./lt.js": 290,
	"./lv": 291,
	"./lv.js": 291,
	"./me": 292,
	"./me.js": 292,
	"./mi": 293,
	"./mi.js": 293,
	"./mk": 294,
	"./mk.js": 294,
	"./ml": 295,
	"./ml.js": 295,
	"./mr": 296,
	"./mr.js": 296,
	"./ms": 297,
	"./ms-my": 298,
	"./ms-my.js": 298,
	"./ms.js": 297,
	"./mt": 299,
	"./mt.js": 299,
	"./my": 300,
	"./my.js": 300,
	"./nb": 301,
	"./nb.js": 301,
	"./ne": 302,
	"./ne.js": 302,
	"./nl": 303,
	"./nl-be": 304,
	"./nl-be.js": 304,
	"./nl.js": 303,
	"./nn": 305,
	"./nn.js": 305,
	"./pa-in": 306,
	"./pa-in.js": 306,
	"./pl": 307,
	"./pl.js": 307,
	"./pt": 308,
	"./pt-br": 309,
	"./pt-br.js": 309,
	"./pt.js": 308,
	"./ro": 310,
	"./ro.js": 310,
	"./ru": 311,
	"./ru.js": 311,
	"./sd": 312,
	"./sd.js": 312,
	"./se": 313,
	"./se.js": 313,
	"./si": 314,
	"./si.js": 314,
	"./sk": 315,
	"./sk.js": 315,
	"./sl": 316,
	"./sl.js": 316,
	"./sq": 317,
	"./sq.js": 317,
	"./sr": 318,
	"./sr-cyrl": 319,
	"./sr-cyrl.js": 319,
	"./sr.js": 318,
	"./ss": 320,
	"./ss.js": 320,
	"./sv": 321,
	"./sv.js": 321,
	"./sw": 322,
	"./sw.js": 322,
	"./ta": 323,
	"./ta.js": 323,
	"./te": 324,
	"./te.js": 324,
	"./tet": 325,
	"./tet.js": 325,
	"./tg": 326,
	"./tg.js": 326,
	"./th": 327,
	"./th.js": 327,
	"./tl-ph": 328,
	"./tl-ph.js": 328,
	"./tlh": 329,
	"./tlh.js": 329,
	"./tr": 330,
	"./tr.js": 330,
	"./tzl": 331,
	"./tzl.js": 331,
	"./tzm": 332,
	"./tzm-latn": 333,
	"./tzm-latn.js": 333,
	"./tzm.js": 332,
	"./ug-cn": 334,
	"./ug-cn.js": 334,
	"./uk": 335,
	"./uk.js": 335,
	"./ur": 336,
	"./ur.js": 336,
	"./uz": 337,
	"./uz-latn": 338,
	"./uz-latn.js": 338,
	"./uz.js": 337,
	"./vi": 339,
	"./vi.js": 339,
	"./x-pseudo": 340,
	"./x-pseudo.js": 340,
	"./yo": 341,
	"./yo.js": 341,
	"./zh-cn": 342,
	"./zh-cn.js": 342,
	"./zh-hk": 343,
	"./zh-hk.js": 343,
	"./zh-tw": 344,
	"./zh-tw.js": 344
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 482;

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_auth__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_config__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(50);









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var vm = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */];

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    state: {
        currentTab: 'media',
        loggedIn: false,
        loggingIn: false,
        loginNotAuth: false,
        loginFailed: false,
        timedOut: false,
        refreshStatus: false,
        refreshStatusCharts: false,
        refreshStatusPacing: false,
        notificationsOpen: false,
        compareChartOpen: {
            media: false,
            website: false
        },
        globalFilters: {
            source: 'All',
            fromDate: null,
            toDate: null
        },
        globalSource: 'All',
        chartFilters: {
            Creative: null,
            Date: null,
            Placement: null
        },
        chartViews: {
            Series: null,
            XValue: 'Date',
            dateGroup: 'Days'
        },
        chartData: {},
        pacingData: {},
        websiteData: {
            tiles: {},
            table: {}
        },
        notificationsData: {},
        newNotifications: false,
        numberOfNewNotifications: 0,
        filter: null,
        mediaSources: []
    },
    mutations: {
        setCurrentTab: function setCurrentTab(state, status) {
            // eslint-disable-next-line
            state.currentTab = status;
        },
        setLoggingIn: function setLoggingIn(state, status) {
            // eslint-disable-next-line
            state.loggingIn = status;
        },
        setLoggedIn: function setLoggedIn(state, status) {
            // eslint-disable-next-line
            state.loggedIn = status;
        },
        setLoginNotAuth: function setLoginNotAuth(state, status) {
            // eslint-disable-next-line
            state.loginNotAuth = status;
        },
        setLoginFailed: function setLoginFailed(state, status) {
            // eslint-disable-next-line
            state.loginFailed = status;
        },
        setTimedOut: function setTimedOut(state, status) {
            // eslint-disable-next-line
            state.timedOut = status;
        },
        setRefreshStatus: function setRefreshStatus(state, status) {
            // eslint-disable-next-line
            state.refreshStatus = status;
        },
        setRefreshStatusCharts: function setRefreshStatusCharts(state, status) {
            // eslint-disable-next-line
            state.refreshStatusCharts = status;
        },
        setRefreshStatusPacing: function setRefreshStatusPacing(state, status) {
            // eslint-disable-next-line
            state.refreshStatusPacing = status;
        },
        setNotificationsOpen: function setNotificationsOpen(state, status) {
            // eslint-disable-next-line
            state.notificationsOpen = status;
        },
        setCompareOpen: function setCompareOpen(state, _ref) {
            var tab = _ref.tab,
                status = _ref.status;

            // eslint-disable-next-line
            state.compareChartOpen[tab] = status;
        },
        setNewNotifications: function setNewNotifications(state, status) {
            // eslint-disable-next-line
            state.newNotifications = status;
        },
        setNumberOfNewNotifications: function setNumberOfNewNotifications(state, status) {
            // eslint-disable-next-line
            state.numberOfNewNotifications = status;
        },
        refreshPacingData: function refreshPacingData(state, newData) {
            // eslint-disable-next-line
            state.pacingData = newData;
        },
        refreshDcmData: function refreshDcmData(state, newData) {
            // eslint-disable-next-line
            state.chartData = newData;
        },
        refreshWebsiteData: function refreshWebsiteData(state, newData) {
            // eslint-disable-next-line
            state.websiteData = newData;
        },
        refreshMediaSources: function refreshMediaSources(state, newData) {
            // eslint-disable-next-line
            state.mediaSources = newData;
        },
        refreshNotificationsData: function refreshNotificationsData(state, newData) {
            // eslint-disable-next-line
            state.notificationsData = newData;
        },
        setGlobalSource: function setGlobalSource(state, newValue) {
            // eslint-disable-next-line
            state.globalSource = newValue;
        },
        updateGlobalFilters: function updateGlobalFilters(state, _ref2) {
            var name = _ref2.name,
                value = _ref2.value;

            // eslint-disable-next-line
            state.globalFilters[name] = value;
        },
        updateChartFilters: function updateChartFilters(state, _ref3) {
            var name = _ref3.name,
                value = _ref3.value;

            // eslint-disable-next-line
            state.chartFilters[name] = value;
        },
        updateChartViews: function updateChartViews(state, _ref4) {
            var name = _ref4.name,
                value = _ref4.value;

            // eslint-disable-next-line
            state.chartViews[name] = value;
        }
    },
    actions: {
        updateCurrentTab: function updateCurrentTab(context, _ref5) {
            var value = _ref5.value;

            context.commit('setCurrentTab', value);
        },
        setNewNotificationsTrue: function setNewNotificationsTrue(context) {
            context.commit('setNewNotifications', true);
        },
        setNewNotificationsFalse: function setNewNotificationsFalse(context) {
            context.commit('setNewNotifications', false);
        },
        loggingInTrue: function loggingInTrue(context) {
            context.commit('setLoggingIn', true);
        },
        loggingInFalse: function loggingInFalse(context) {
            context.commit('setLoggingIn', false);
        },
        logout: function logout(context) {
            context.commit('setLoggedIn', false);
        },
        login: function login(context) {
            context.commit('setLoggedIn', true);
        },
        openNotifications: function openNotifications(context) {
            context.commit('setNotificationsOpen', true);
        },
        closeNotifications: function closeNotifications(context) {
            context.commit('setNotificationsOpen', false);
        },
        openCompare: function openCompare(context, _ref6) {
            var tab = _ref6.tab;

            context.commit('setCompareOpen', {
                tab: tab,
                status: true
            });
        },
        closeCompare: function closeCompare(context, _ref7) {
            var tab = _ref7.tab;

            context.commit('setCompareOpen', {
                tab: tab,
                status: false
            });
        },
        updateGlobalFilters: function updateGlobalFilters(context, payload) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                context.commit('updateGlobalFilters', payload);
                resolve();
            });
        },
        updateGlobalSource: function updateGlobalSource(context, payload) {
            context.commit('setGlobalSource', payload);
        },
        updateChartFilters: function updateChartFilters(context, payload) {
            context.commit('updateChartFilters', payload);
        },
        updateChartViews: function updateChartViews(context, payload) {
            context.commit('updateChartViews', payload);
        },
        refreshAllData: function refreshAllData(context) {
            context.commit('setRefreshStatus', true);
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([context.dispatch('refreshPacingData'), context.dispatch('refreshDcmData'), context.dispatch('refreshMediaSources'), context.dispatch('refreshWebsiteData')]).then(function () {
                context.commit('setRefreshStatusPacing', false);
                context.commit('setRefreshStatusCharts', false);
                context.commit('setRefreshStatus', false);
                context.commit('setRefreshStatusCharts', false);
            });
        },
        refreshPacingData: function refreshPacingData(context) {
            context.commit('setRefreshStatusPacing', true);

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var getUrl = __WEBPACK_IMPORTED_MODULE_4__util_config__["b" /* urls */].PACING_DATA_URL;
                var params = {};

                if (context.state.globalFilters.source) {
                    params.mediaSource = context.state.globalFilters.source;
                }

                if (context.state.globalFilters.fromDate) {
                    params.dateFrom = context.state.globalFilters.fromDate;
                }

                if (context.state.globalFilters.toDate) {
                    params.dateTo = context.state.globalFilters.toDate;
                }

                var config = {
                    params: params,
                    headers: __WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].getAuthHeader()
                };

                if (__WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].checkAuth()) {
                    vm.http.get(getUrl, config).then(function (res) {
                        if (res.status === 200) {
                            context.commit('refreshPacingData', res.body);
                            resolve();
                        } else {
                            console.log('error in get pacing', res);
                        }
                    });
                } else {
                    context.commit('setTimedOut', true);
                    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
                        name: 'Login'
                    });
                    resolve();
                }
            });
        },
        refreshDcmData: function refreshDcmData(context) {
            context.commit('setRefreshStatusCharts', true);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var getUrl = __WEBPACK_IMPORTED_MODULE_4__util_config__["b" /* urls */].DCM_DATA_URL;
                var params = {};

                if (context.state.globalFilters.source) {
                    params.mediaSource = context.state.globalFilters.source;
                }

                if (context.state.globalFilters.fromDate) {
                    params.dateFrom = context.state.globalFilters.fromDate;
                }

                if (context.state.globalFilters.toDate) {
                    params.dateTo = context.state.globalFilters.toDate;
                }

                var config = {
                    params: params,
                    headers: __WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].getAuthHeader()
                };

                if (__WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].checkAuth()) {
                    vm.http.get(getUrl, config).then(function (res) {
                        if (res.status === 200) {
                            context.commit('refreshDcmData', res.body);
                            resolve();
                        } else {
                            console.log('error in dcm get', res);
                        }
                    });
                } else {
                    context.commit('setTimedOut', true);
                    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
                        name: 'Login'
                    });
                    resolve();
                }
            });
        },
        refreshWebsiteData: function refreshWebsiteData(context) {
            context.commit('setRefreshStatusCharts', true);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var getUrl = __WEBPACK_IMPORTED_MODULE_4__util_config__["b" /* urls */].WEBSITE_ANALYTICS_URL;
                var params = {};

                if (context.state.globalFilters.source) {
                    params.mediaSource = context.state.globalFilters.source;
                }

                if (context.state.globalFilters.fromDate) {
                    params.dateFrom = context.state.globalFilters.fromDate;
                }

                if (context.state.globalFilters.toDate) {
                    params.dateTo = context.state.globalFilters.toDate;
                }

                var config = {
                    params: params,
                    headers: __WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].getAuthHeader()
                };

                if (__WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].checkAuth()) {
                    vm.http.get(getUrl, config).then(function (res) {
                        if (res.status === 200) {
                            context.commit('refreshWebsiteData', res.body);
                            resolve();
                        } else {
                            console.log('error in website data get', res);
                        }
                    });
                } else {
                    context.commit('setTimedOut', true);
                    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
                        name: 'Login'
                    });
                    resolve();
                }
            });
        },
        refreshMediaSources: function refreshMediaSources(context) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var config = {
                    headers: __WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].getAuthHeader()
                };

                if (__WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].checkAuth()) {
                    vm.http.get(__WEBPACK_IMPORTED_MODULE_4__util_config__["b" /* urls */].MEDIA_SOURCES_URL, config).then(function (res) {
                        if (res.status === 200) {
                            context.commit('refreshMediaSources', res.body);
                            resolve();
                        } else {
                            console.log('error in media sources get', res);
                        }
                    });
                } else {
                    context.commit('setTimedOut', true);
                    __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
                        name: 'Login'
                    });
                    resolve();
                }
            });
        },
        refreshNotificationsData: function refreshNotificationsData(context) {
            var config = {
                headers: __WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].getAuthHeader()
            };

            var getUrl = '' + __WEBPACK_IMPORTED_MODULE_4__util_config__["b" /* urls */].NOTIFICATIONS_URL + localStorage.getItem('userId') + '/';

            if (__WEBPACK_IMPORTED_MODULE_3__util_auth__["a" /* default */].checkAuth()) {
                vm.http.get(getUrl, config).then(function (res) {
                    if (res.status === 200) {
                        var newNotifications = res.body.notifications.filter(function (notification) {
                            return new Date(localStorage.getItem('lastLogin')) <= new Date(notification.updated_at);
                        });

                        if (newNotifications.length) {
                            context.commit('setNewNotifications', true);
                        }
                        context.commit('setNumberOfNewNotifications', newNotifications.length);

                        context.commit('refreshNotificationsData', res.body);
                    } else {
                        console.log('error in notification get', res);
                    }
                }).catch(function (e) {
                    return console.log(e);
                });
            } else {
                context.commit('setTimedOut', true);
                __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
                    name: 'Login'
                });
            }
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Home__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Login__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_NotFound__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_auth__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(5);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    mode: 'history',
    base: '%%ROUTER_BASE%%',
    routes: [{
        path: '/login/',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Login__["a" /* default */],
        beforeEnter: function beforeEnter(to, from, next) {
            if (__WEBPACK_IMPORTED_MODULE_6__util_auth__["a" /* default */].checkAuth()) {
                next({
                    name: 'Home'
                });
            } else {
                next();
            }
        }
    }, {
        path: '/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Home__["a" /* default */],
        props: { appData: this.props },
        beforeEnter: function beforeEnter(to, from, next) {
            var queryKeyNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(to.query);
            if (queryKeyNames.length) {
                queryKeyNames.forEach(function (keyName) {
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.globalFilters).includes(keyName)) {
                        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('updateGlobalFilters', { name: keyName, value: to.query[keyName] });
                    } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.chartFilters).includes(keyName)) {
                        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('updateChartFilters', { name: keyName, value: to.query[keyName] });
                    } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.chartViews).includes(keyName)) {
                        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('updateChartViews', { name: keyName, value: to.query[keyName] });
                    } else if (keyName === 'currentTab') {
                        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setCurrentTab', to.query[keyName]);
                    }
                });
            }
            if (!__WEBPACK_IMPORTED_MODULE_6__util_auth__["a" /* default */].checkAuth()) {
                next({
                    name: 'Login'
                });
            } else {
                next();
            }
        }
    }, {
        path: '*',
        name: 'NotFound',
        component: __WEBPACK_IMPORTED_MODULE_5__components_pages_NotFound__["a" /* default */]
    }]
}));

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"appear":"","name":"fade","mode":"out-in"}},[_c('div',{staticClass:"card"},[(_vm.hasChartData)?_c('div',{ref:"lineChartContainer",staticClass:"charts"},[_c('canvas',{ref:"lineCanvas"})]):_c('h1',{staticClass:"no-data"},[_vm._v("\n                No data for those filters\n            ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableChart_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e876146_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableChart_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e876146"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e876146_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"appear":"","name":"fade","mode":"out-in"}},[_c('div',{staticClass:"chart-table"},[_c('table',{staticClass:"table"},[_c('thead',[_c('th',[_vm._v("Item")]),_vm._v(" "),_vm._l((_vm.series),function(heading){return _c('th',{key:heading},[_vm._v(_vm._s(heading))])})],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.tableData),function(cValue,cName){return [_c('tr',{key:'creative' + cName,staticClass:"creative"},[_c('th',[_vm._v(_vm._s(cName))]),_vm._v(" "),_vm._l((cValue.values),function(cValuesValue,cValuesName){return _c('td',{key:cName + cValuesName},[_vm._v(_vm._s(cValuesValue))])})],2),_vm._v(" "),_vm._l((cValue.placements),function(pValue,pName){return [_c('tr',{key:'placement' + cName + pName,staticClass:"placement"},[_c('th',[_vm._v(_vm._s(pName))]),_vm._v(" "),_vm._l((pValue.values),function(pValuesValue,pValuesName){return _c('td',{key:cName + pName + pValuesName},[_vm._v(_vm._s(pValuesValue))])})],2),_vm._v(" "),_vm._l((pValue.dates),function(dValue,dName){return _c('tr',{key:'date' + cName + pName + dName,staticClass:"date"},[_c('th',[_vm._v(_vm._s(dName))]),_vm._v(" "),_vm._l((dValue.values),function(dValuesValue,dValuesName){return _c('td',{key:cName + pName + dName + dValuesName},[_vm._v(_vm._s(dValuesValue))])})],2)})]})]})],2)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filters row no-gutters",class:{ 'compare-open': _vm.compareOpen }},[_c('div',{staticClass:"filter-column"},[_c('select-input',{staticClass:"filter",attrs:{"placeholder":"Units","options":_vm.series,"searchable":false,"value":_vm.views.Series,"inputId":"Series"},on:{"input":function (value) { return _vm.viewsUpdate('Series' , value); }}})],1),_vm._v(" "),_vm._l((_vm.uniqueCategories),function(category){return _c('div',{key:category,staticClass:"filter-column"},[_c('select-input',{staticClass:"filter",attrs:{"placeholder":category,"options":_vm.uniqueCategoryValues[category],"value":_vm.filters[category],"searchable":false,"inputId":category,"disabled":category === 'Creative' && !_vm.filters.Placement,"passThroughClass":category},on:{"input":function (value) { return _vm.filterUpdate(("" + category), value); }}})],1)})],2),_vm._v(" "),_c('div',{staticClass:"reset-container"},[_c('button',{staticClass:"reset-button",on:{"click":_vm.reset}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"chart"},[_c('div',{staticClass:"controls row no-gutters"},[_c('div',{staticClass:"control-column"},[_c('select-input',{staticClass:"filter",attrs:{"placeholder":"By time/Ad unit","options":_vm.uniqueCategories,"value":_vm.views.XValue,"searchable":false,"inputId":"XValue"},on:{"input":function (value) { return _vm.viewsUpdate('XValue' , value); }}})],1),_vm._v(" "),_c('div',{staticClass:"control-column"},[_c('select-input',{staticClass:"filter",attrs:{"placeholder":"Date group","options":_vm.dateGroupList,"value":_vm.views.dateGroup,"searchable":false,"inputId":"dateGroup"},on:{"input":function (value) { return _vm.viewsUpdate('dateGroup' , value); }}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.unselectedXAxis),expression:"unselectedXAxis"}],staticClass:"no-data-text text-center font-arial"},[_vm._v("Please select a value for \"By time/Ad unit\"")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.unselectedXAxis),expression:"!unselectedXAxis"}],staticClass:"toggle-buttons"},[_c('button',{class:{ selected: _vm.showTable },attrs:{"title":"Change to table view"},on:{"click":_vm.toTable}},[_c('div',{staticClass:"icon icon--table"}),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v("Change To Table")])]),_vm._v(" "),_c('button',{class:{ selected: !_vm.showTable },attrs:{"title":"Change to chart view"},on:{"click":_vm.toChart}},[_c('div',{staticClass:"icon icon--graph"}),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v("Change To Chart")])])]),_vm._v(" "),(!_vm.showTable)?_c('line-chart',{directives:[{name:"show",rawName:"v-show",value:(!_vm.unselectedXAxis),expression:"!unselectedXAxis"}],staticClass:"chart-wrapper",attrs:{"views":_vm.views,"uniqueCategories":_vm.uniqueCategories,"filters":_vm.filters,"series":_vm.series}}):_vm._e(),_vm._v(" "),(_vm.showTable)?_c('table-chart',{directives:[{name:"show",rawName:"v-show",value:(!_vm.unselectedXAxis),expression:"!unselectedXAxis"}],staticClass:"chart-wrapper",attrs:{"views":_vm.views,"uniqueCategories":_vm.uniqueCategories,"filters":_vm.filters,"series":_vm.series}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-container"},[(_vm.chartDataExists)?[_c('div',{staticClass:"d-flex justify-content-end"},[_c('div',{staticClass:"compare-open"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.compareOpen)?_c('button',{key:"openComparison",staticClass:"add-comparison",on:{"click":_vm.openComparison}},[_c('span',{staticClass:"icon icon--inline icon--add"}),_vm._v(" Add Comparison\n                    ")]):_vm._e(),_vm._v(" "),(_vm.compareOpen)?_c('button',{key:"closeComparison",class:{ 'is-compare-open': _vm.compareOpen },on:{"click":_vm.closeComparison}},[_c('span',{staticClass:"icon icon--inline icon--remove"}),_vm._v(" Remove Comparison\n                    ")]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters flex-nowrap toggle-wrapper"},[_c('div',{key:"left",ref:"leftChart",staticClass:"left-chart",class:{ 'col-md-12': !_vm.compareOpen, 'col-md-6': _vm.compareOpen, 'left-split': _vm.compareOpen }},[_c('toggle-chart-container',{attrs:{"updateFilters":true}})],1),_vm._v(" "),_c('transition',{staticClass:"row no-gutters justify-content-between",attrs:{"name":"compa"}},[(_vm.compareOpen)?_c('div',{key:"right",staticClass:"right-chart col-md-6",class:{ 'right-split': _vm.compareOpen }},[_c('toggle-chart-container')],1):_vm._e()])],1)]:_c('h1',{staticClass:"no-data"},[_vm._v("\n        No data for those filters\n    ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PacingTable_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0566c60e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PacingTable_vue__ = __webpack_require__(513);
function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0566c60e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PacingTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0566c60e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PacingTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 508:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-container"},[(_vm.pacingDataExists)?_c('div',{staticClass:"pacing-table-container"},[_c('h3',[_vm._v("Pacing Table")]),_vm._v(" "),_c('div',{staticClass:"pagination"},[(_vm.pageNumber !== 1)?_c('button',{staticClass:"previous-button",on:{"click":_vm.previous}},[_c('span',{staticClass:"icon icon--inline icon--arrow-left"}),_vm._v(" Previous\n            ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"page-number font-arial"},[_vm._v("\n                "+_vm._s(_vm.pageNumber)+" of "+_vm._s(_vm.tableData.body.length)+"\n            ")]),_vm._v(" "),(_vm.pageNumber !== _vm.tableData.body.length)?_c('button',{staticClass:"next-button",on:{"click":_vm.next}},[_vm._v("\n                Next "),_c('span',{staticClass:"icon icon--inline icon--arrow-right"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pacing-table"},[_c('transition-group',{staticClass:"table",style:({ height: (_vm.tableHeight + "px") }),attrs:{"name":_vm.slideName(),"tag":"table"},on:{"enter":_vm.setTableHeight}},[_c('thead',{key:"thead",ref:"thead"},[_c('tr',_vm._l((_vm.tableData.head),function(heading){return _c('th',{key:heading},[_vm._v(_vm._s(heading))])}))]),_vm._v(" "),_vm._l((_vm.tableData.body),function(page,pageIndex){return ((_vm.pageNumber - 1) === pageIndex)?_c('tbody',{key:("bodyPage" + pageIndex),ref:("body" + pageIndex),refInFor:true,staticClass:"table-body"},_vm._l((page),function(row,rowIndex){return _c('tr',{key:(pageIndex + "row" + rowIndex)},[_vm._l((row.categories),function(cell,cellIndex){return _c('th',{key:("row" + rowIndex + "category" + cellIndex)},[_vm._v(_vm._s(cell))])}),_vm._v(" "),_vm._l((row.values),function(cell,cellIndex){return _c('td',{key:("row" + rowIndex + "value" + cellIndex)},[_vm._v(_vm._s(cell))])})],2)})):_vm._e()})],2)],1)]):_c('h1',{staticClass:"no-data"},[_vm._v("\n        No data for those filters\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-container"},[_c('div',{staticClass:"title d-md-none"},[_vm._v("Media")]),_vm._v(" "),_c('media-tile-container'),_vm._v(" "),_c('transition',{attrs:{"name":"fade-chart","mode":"out-in"}},[(_vm.refreshingCharts)?_c('h1',{staticClass:"max-container loading"},[_vm._v("Loading charts"),_c('span',{staticClass:"indicator"},[_vm._v(".")]),_c('span',{staticClass:"indicator"},[_vm._v(".")]),_c('span',{staticClass:"indicator"},[_vm._v(".")])]):_vm._e(),_vm._v(" "),(!_vm.refreshingCharts && _vm.chartData.data)?_c('big-chart-container',{staticClass:"chart-container"}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebsiteContainer_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb7651c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebsiteContainer_vue__ = __webpack_require__(523);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4eb7651c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebsiteContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb7651c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebsiteContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebsiteTileContainer_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bef3e66_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebsiteTileContainer_vue__ = __webpack_require__(519);
function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bef3e66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebsiteTileContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bef3e66_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebsiteTileContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile-container"},[_c('div',{staticClass:"max-container"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"tile-wrapper col-6 col-md-3"},[_c('stat-tile',{staticClass:"tile",attrs:{"mobileText":"Visits to homepage","text":"Visits to homepage","number":_vm.views,"icon":"monitor","percent":_vm.viewsPercent,"target":_vm.viewsTarget,"flip":true,"color":"teal"}})],1),_vm._v(" "),_c('div',{staticClass:"tile-wrapper col-6 col-md-3"},[_c('stat-tile',{staticClass:"tile",attrs:{"mobileText":"Average time on site","text":"Average time<br>spend on site","time":_vm.averageTime,"icon":"clock","percent":_vm.averageTimePercent,"target":_vm.averageTimeTarget,"flip":true,"color":"pink"}})],1),_vm._v(" "),_c('div',{staticClass:"tile-wrapper col-6 col-md-3"},[_c('stat-tile',{staticClass:"tile",attrs:{"mobileText":"Bounce rate","text":"Bounce rate","number":_vm.bounceRate,"icon":"monitor-bounce","percent":_vm.bounceRatePercent,"target":_vm.bounceRateTarget,"flip":true,"color":"purple","percentage":true}})],1),_vm._v(" "),_c('div',{staticClass:"tile-wrapper col-6 col-md-3"},[_c('stat-tile',{staticClass:"tile",attrs:{"mobileText":"Number of conversions","text":"Number of conversions","number":_vm.conversions,"icon":"conversions","percent":_vm.conversionsPercent,"target":_vm.conversionsTarget,"flip":true,"color":"orange"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebsiteTable_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_944f38c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebsiteTable_vue__ = __webpack_require__(522);
function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-944f38c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebsiteTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_944f38c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebsiteTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 521:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-container"},[(_vm.pacingDataExists)?_c('div',{staticClass:"pacing-table-container"},[_c('div',{staticClass:"pagination"},[(_vm.pageNumber !== 1)?_c('button',{staticClass:"previous-button",on:{"click":_vm.previous}},[_c('span',{staticClass:"icon icon--inline icon--arrow-left"}),_vm._v(" Previous\n            ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"page-number font-arial"},[_vm._v("\n                "+_vm._s(_vm.pageNumber)+" of "+_vm._s(_vm.tableData.body.length)+"\n            ")]),_vm._v(" "),(_vm.pageNumber !== _vm.tableData.body.length)?_c('button',{staticClass:"next-button",on:{"click":_vm.next}},[_vm._v("\n                Next "),_c('span',{staticClass:"icon icon--inline icon--arrow-right"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pacing-table"},[_c('transition-group',{staticClass:"table",style:({ height: (_vm.tableHeight + "px") }),attrs:{"name":_vm.slideName(),"tag":"table"},on:{"enter":_vm.setTableHeight}},[_c('thead',{key:"thead",ref:"thead"},[_c('tr',_vm._l((_vm.tableData.head),function(heading){return _c('th',{key:heading},[_vm._v(_vm._s(heading))])}))]),_vm._v(" "),_vm._l((_vm.tableData.body),function(page,pageIndex){return ((_vm.pageNumber - 1) === pageIndex)?_c('tbody',{key:("bodyPage" + pageIndex),staticClass:"table-body"},_vm._l((page),function(row,rowIndex){return _c('tr',{key:(pageIndex + "row" + rowIndex)},[_vm._l((row.categories),function(cell,cellIndex){return _c('th',{key:("row" + rowIndex + "category" + cellIndex)},[_vm._v(_vm._s(cell))])}),_vm._v(" "),_vm._l((row.values),function(cell,cellIndex){return _c('td',{key:("row" + rowIndex + "value" + cellIndex)},[_vm._v(_vm._s(cell))])})],2)})):_vm._e()})],2)],1)]):_c('h1',{staticClass:"no-data"},[_vm._v("\n        No data for those filters\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"website-container"},[_c('div',{staticClass:"title d-md-none"},[_vm._v("Website")]),_vm._v(" "),_c('website-tile-container'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.refreshingPacing)?_c('h1',{staticClass:"max-container loading"},[_vm._v("Loading table"),_c('span',{staticClass:"indicator"},[_vm._v(".")]),_c('span',{staticClass:"indicator"},[_vm._v(".")]),_c('span',{staticClass:"indicator"},[_vm._v(".")])]):_vm._e(),_vm._v(" "),(!_vm.refreshingPacing && _vm.tableData)?_c('website-table'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-container"},[_c('transition-group',{staticClass:"tabs",attrs:{"tag":"div","name":"tab"}},[(_vm.currentTab === 'media')?_c('media-container',{key:"media"}):_vm._e(),_vm._v(" "),(_vm.currentTab === 'website')?_c('website-container',{key:"website"}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommentsContainer_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7323a2ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommentsContainer_vue__ = __webpack_require__(527);
function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7323a2ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommentsContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7323a2ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommentsContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 526:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal font-arial"},[_c('div',{staticClass:"modal-heading-bar"},[_c('h1',[_vm._v("Notifications")]),_vm._v(" "),_c('div',{staticClass:"modal-close",on:{"click":_vm.closeNotifications}},[_c('div',{staticClass:"icon icon--close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-content"},_vm._l((_vm.notifications),function(notification){return _c('div',{key:notification.notification_id,staticClass:"notification"},[_c('h2',[_vm._v("\n                    "+_vm._s(notification.notification_heading)+"\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    "+_vm._s(notification.notification_body)+"\n                ")])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('filters-container'),_vm._v(" "),_c('tab-container'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.notificationsOpen)?_c('comments-container'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7074052c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(531);
function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7074052c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7074052c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 530:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper"},[_c('div',{staticClass:"login"},[_c('h1',[_vm._v("Login")]),_vm._v(" "),(_vm.timedOut)?_c('div',{staticClass:"row no-gutters"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row no-gutters fields"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"field field-left"},[_c('label',{attrs:{"for":"username"}},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"placeholder":"username","name":"username","type":"text"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"field field-right"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"placeholder":"password","name":"password","type":"password"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.submit($event)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])])]),_vm._v(" "),(_vm.notAuth)?_c('div',{staticClass:"row no-gutters"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.loginFailed)?_c('div',{staticClass:"row no-gutters"},[_vm._m(2)]):_vm._e(),_vm._v(" "),_c('button',{on:{"click":_vm.submit}},[(!_vm.loggingIn)?_c('span',[_vm._v("Login")]):_vm._e(),_vm._v(" "),(_vm.loggingIn)?_c('span',[_vm._v("Logging In..")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"timed-out text-red text-center font-arial"},[_vm._v("\n                    You have been logged out due to a period of inactivity."),_c('br'),_vm._v("\n                    Please log back in.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"not-auth text-red text-center font-arial"},[_vm._v("\n                    Your username and/or password were not recognised."),_c('br'),_vm._v("\n                    Please try again.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"not-auth text-red text-center font-arial"},[_vm._v("\n                    Sorry there was a problem logging in."),_c('br'),_vm._v("\n                    Please try again later.\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b29b94f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__(534);
function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b29b94f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b29b94f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 533:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Page Not Found")]),_vm._v(" "),_c('h2',[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("Go to Home")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-header"},[_c('div',{staticClass:"nav__bar max-container"},[_c('div',{staticClass:"d-flex justify-content-between"},[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"d-flex"},[_c('button',{staticClass:"nav__bar__item nav__bar__item--notifications",class:{ open: _vm.notificationsOpen, inactive: !_vm.loggedIn },on:{"click":_vm.toggleNotifications}},[_c('div',{staticClass:"icon icon--flex icon--notifications"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.newNotifications)?_c('div',{staticClass:"notification-toggle"},[_c('span',[_vm._v(_vm._s(_vm.numberOfNewNotifications))])]):_vm._e()])],1),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v("Open Notifications")])]),_vm._v(" "),_c('button',{staticClass:"nav__bar__item nav__bar__item--logout",class:{ inactive: !_vm.loggedIn },on:{"click":_vm.logout}},[_c('div',{staticClass:"icon icon--flex icon--logout"}),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v("Log out")])])])])]),_vm._v(" "),_c('div',{staticClass:"max-container header"},[_c('header',{staticClass:"header__bar d-md-flex justify-content-between",class:{ inactive: !_vm.loggedIn }},[_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav__bar__logo__wrapper"},[_c('div',{staticClass:"nav__bar__logo"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__bar__title__wrapper"},[_c('h1',{staticClass:"header__bar__title"},[_vm._v("KPMG Media Reporting")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dffe5490_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__(538);
function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dffe5490"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dffe5490_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 537:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-header',{ref:"$navHeader"}),_vm._v(" "),_c('main',{ref:"mainThing"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavHeader__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SideBar__ = __webpack_require__(536);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: {
        NavHeader: __WEBPACK_IMPORTED_MODULE_0__components_NavHeader__["a" /* default */],
        SideBar: __WEBPACK_IMPORTED_MODULE_1__components_SideBar__["a" /* default */]
    }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_auth__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        refreshing: function refreshing() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.refreshStatus;
        },
        notificationsOpen: function notificationsOpen() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.notificationsOpen;
        },
        loggedIn: function loggedIn() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.loggedIn;
        },
        newNotifications: function newNotifications() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.newNotifications;
        },
        numberOfNewNotifications: function numberOfNewNotifications() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.numberOfNewNotifications;
        }
    },
    methods: {
        toggleNotifications: function toggleNotifications() {
            if (this.loggedIn) {
                if (this.notificationsOpen) {
                    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('closeNotifications');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('openNotifications');
                    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('setNewNotificationsFalse');
                }
            }
        },
        openNotifications: function openNotifications() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('openNotifications');
        },
        closeNotifications: function closeNotifications() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('closeNotifications');
        },
        logout: function logout() {
            __WEBPACK_IMPORTED_MODULE_0__util_auth__["a" /* default */].logout();
        }
    }
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FiltersContainer__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TabContainer__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CommentsContainer__ = __webpack_require__(525);
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        FiltersContainer: __WEBPACK_IMPORTED_MODULE_1__components_FiltersContainer__["a" /* default */],
        TabContainer: __WEBPACK_IMPORTED_MODULE_2__components_TabContainer__["a" /* default */],
        CommentsContainer: __WEBPACK_IMPORTED_MODULE_3__components_CommentsContainer__["a" /* default */]
    },
    computed: {
        commentsData: function commentsData() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.appData.comments;
        },
        notificationsOpen: function notificationsOpen() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.notificationsOpen;
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('refreshAllData');
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('refreshNotificationsData');
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('refreshDcmData', {});
    }
});

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_filters_DateInput__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filters_SelectInput__ = __webpack_require__(77);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        DateInput: __WEBPACK_IMPORTED_MODULE_2__components_filters_DateInput__["a" /* default */],
        SelectInput: __WEBPACK_IMPORTED_MODULE_3__components_filters_SelectInput__["a" /* default */]
    },
    data: function data() {
        return {
            filterOpen: false
        };
    },

    computed: {
        currentTabFormatted: function currentTabFormatted() {
            var text = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.currentTab;
            return text.replace(text[0], text[0].toUpperCase());
        },
        currentTab: function currentTab() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.currentTab;
        },
        fromDate: function fromDate() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.globalFilters.fromDate;
        },
        toDate: function toDate() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.globalFilters.toDate;
        },
        tabChoices: function tabChoices() {
            return [{ label: 'Media', value: 'media' }, { label: 'Website', value: 'website' }];
        },
        globalSource: function globalSource() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.globalSource;
        },
        mediaSources: function mediaSources() {
            var initial = [{
                label: 'All',
                value: 'All'
            }];

            var sources = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.mediaSources.sources;

            if (sources) {
                sources.forEach(function (e) {
                    var optionObj = {
                        label: e.source_name,
                        value: e.source_value
                    };

                    initial.push(optionObj);
                });
            }

            return initial;
        }
    },
    methods: {
        toggleFilterOpen: function toggleFilterOpen() {
            this.filterOpen = !this.filterOpen;
        },
        reset: function reset() {
            var resets = [];

            resets.push(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('updateGlobalFilters', {
                name: 'fromDate',
                value: null
            }));

            resets.push(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('updateGlobalFilters', {
                name: 'toDate',
                value: null
            }));

            resets.push(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('updateGlobalFilters', {
                name: 'source',
                value: 'All'
            }));

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(resets).then(function () {
                return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('refreshAllData');
            });
        },
        fromDisabled: function fromDisabled() {
            if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.chartData.campaignStartDate) {
                var startDate = new Date(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.chartData.campaignStartDate);

                return {
                    to: startDate
                };
            }

            return {};
        },
        toDisabled: function toDisabled() {
            if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.chartData.campaignStartDate) {
                var endDate = new Date(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.chartData.campaignEndDate);
                endDate.setDate(endDate.getDate() + 1);

                return {
                    from: endDate
                };
            }

            return {};
        },
        updateSource: function updateSource(value) {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('updateGlobalSource', this.mediaSources.map(function (o) {
                return o.value === value;
            }).source);

            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('updateGlobalFilters', {
                name: 'source',
                value: value
            }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('refreshAllData');
            });
        },
        updateFromDate: function updateFromDate(value) {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('updateGlobalFilters', {
                name: 'fromDate',
                value: value
            }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('refreshAllData');
            });
        },
        updateToDate: function updateToDate(value) {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('updateGlobalFilters', {
                name: 'toDate',
                value: value
            }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('refreshAllData');
            });
        },
        updateCurrentTab: function updateCurrentTab(newValue) {
            var value = newValue;

            if (newValue === null) {
                value = 'Media';
            }

            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('updateCurrentTab', {
                value: value.toLowerCase()
            });
        }
    }
});

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        DatePicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker___default.a
    },
    props: {
        placeholder: {},
        disabled: {
            type: Object,
            default: function _default() {}
        },
        val: {},
        inputId: {}
    },
    data: function data() {
        return {
            open: false
        };
    },

    methods: {
        opened: function opened() {
            this.open = true;
        },
        closed: function closed() {
            this.open = false;
        },
        inputUpdate: function inputUpdate(date) {
            var value = null;
            if (date) {
                var month = date.getMonth() + 1;
                var padMonth = month.toString().padStart(2, '0');
                var padDate = date.getDate().toString().padStart(2, '0');

                value = date.getFullYear() + '-' + padMonth + '-' + padDate;
            }

            this.$emit('input', value);
        }
    }
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectInput_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd1d19e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectInput_vue__ = __webpack_require__(431);
function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efd1d19e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forks_select__ = __webpack_require__(409);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    model: {
        prop: 'selectedCreative',
        event: 'cha'
    },
    props: ['inputId', 'label', 'options', 'placeholder', 'value', 'searchable', 'disabled', 'passThroughClass'],
    data: function data() {
        return {
            selected: false
        };
    },

    components: {
        Selector: __WEBPACK_IMPORTED_MODULE_0__components_forks_select__["a" /* default */]
    },
    methods: {
        inputUpdate: function inputUpdate(e) {
            // const name = this.name;
            var value = null;

            if (e && e.value) {
                value = e.value;
            } else {
                value = e;
            }

            if (value === null) {
                this.selected = false;
            } else {
                this.selected = true;
            }

            this.$emit('input', value);
        }
    }
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_pointerScroll__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_pointerScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mixins_pointerScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_typeAheadPointer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_typeAheadPointer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mixins_typeAheadPointer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_ajax__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mixins_ajax__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_pointerScroll___default.a, __WEBPACK_IMPORTED_MODULE_4__mixins_typeAheadPointer___default.a, __WEBPACK_IMPORTED_MODULE_5__mixins_ajax___default.a],

  props: {
    /**
     * Contains the currently selected value. Very similar to a
     * `value` attribute on an <input>. You can listen for changes
     * using 'change' event using v-on
     * @type {Object||String||null}
     */
    value: {
      default: null
    },

    /**
     * An array of strings or objects to be used as dropdown choices.
     * If you are using an array of objects, vue-select will look for
     * a `label` key (ex. [{label: 'This is Foo', value: 'foo'}]). A
     * custom label key can be set with the `label` prop.
     * @type {Array}
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Disable the entire component.
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Sets the max-height property on the dropdown list.
     * @deprecated
     * @type {String}
     */
    maxHeight: {
      type: String,
      default: '400px'
    },

    /**
     * Enable/disable filtering the options.
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },

    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * Equivalent to the `placeholder` attribute on an `<input>`.
     * @type {String}
     */
    placeholder: {
      type: String,
      default: ''
    },

    /**
     * Sets a Vue transition property on the `.dropdown-menu`. vue-select
     * does not include CSS for transitions, you'll need to add them yourself.
     * @type {String}
     */
    transition: {
      type: String,
      default: 'fade'
    },

    /**
     * Enables/disables clearing the search text when an option is selected.
     * @type {Boolean}
     */
    clearSearchOnSelect: {
      type: Boolean,
      default: true
    },

    /**
     * Close a dropdown when an option is chosen. Set to false to keep the dropdown
     * open (useful when combined with multi-select, for example)
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },

    /**
     * Tells vue-select what key to use when generating option
     * labels when each `option` is an object.
     * @type {String}
     */
    label: {
      type: String,
      default: 'label'
    },

    /**
     * Callback to generate the label text. If {option}
     * is an object, returns option[this.label] by default.
     * @type {Function}
     * @param  {Object || String} option
     * @return {String}
     */
    getOptionLabel: {
      type: Function,
      default: function _default(option) {
        if ((typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(option)) === 'object') {
          if (this.label && option[this.label]) {
            return option[this.label];
          }
        }
        return option;
      }
    },

    /**
     * An optional callback function that is called each time the selected
     * value(s) change. When integrating with Vuex, use this callback to trigger
     * an action, rather than using :value.sync to retreive the selected value.
     * @type {Function}
     * @param {Object || String} val
     */
    onChange: {
      type: Function,
      default: function _default(val) {
        this.$emit('input', val);
      }
    },

    /**
     * Enable/disable creating options from searchInput.
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },

    /**
     * Set the tabindex for the input field.
     * @type {Number}
     */
    tabindex: {
      type: Number,
      default: null
    },

    /**
     * When true, newly created tags will be added to
     * the options list.
     * @type {Boolean}
     */
    pushTags: {
      type: Boolean,
      default: false
    },

    /**
     * When true, existing options will be filtered
     * by the search text. Should not be used in conjunction
     * with taggable.
     * @type {Boolean}
     */
    filterable: {
      type: Boolean,
      default: true
    },

    /**
     * User defined function for adding Options
     * @type {Function}
     */
    createOption: {
      type: Function,
      default: function _default(newOption) {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.mutableOptions[0]) === 'object') {
          newOption = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.label, newOption);
        }
        this.$emit('option:created', newOption);
        return newOption;
      }
    },

    /**
     * When false, updating the options will not reset the select value
     * @type {Boolean}
     */
    resetOnOptionsChange: {
      type: Boolean,
      default: false
    },

    /**
     * Disable the dropdown entirely.
     * @type {Boolean}
     */
    noDrop: {
      type: Boolean,
      default: false
    },

    /**
     * Sets the id of the input element.
     * @type {String}
     * @default {null}
     */
    inputId: {
      type: String
    },

    /**
     * Sets RTL support. Accepts 'ltr', 'rtl', 'auto'.
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir
     * @type {String}
     * @default 'auto'
     */
    dir: {
      type: String,
      default: 'auto'
    }
  },

  data: function data() {
    return {
      search: '',
      open: false,
      mutableValue: null,
      mutableOptions: []
    };
  },


  watch: {
    /**
     * When the value prop changes, update
    * the internal mutableValue.
     * @param  {mixed} val
     * @return {void}
     */
    value: function value(val) {
      this.mutableValue = val;
    },


    /**
     * Maybe run the onChange callback.
     * @param  {string|object} val
     * @param  {string|object} old
     * @return {void}
     */
    mutableValue: function mutableValue(val, old) {
      if (this.multiple) {
        this.onChange ? this.onChange(val) : null;
      } else {
        this.onChange && val !== old ? this.onChange(val) : null;
      }
    },


    /**
     * When options change, update
     * the internal mutableOptions.
     * @param  {array} val
     * @return {void}
     */
    options: function options(val) {
      this.mutableOptions = val;
    },


    /**
    * Maybe reset the mutableValue
     * when mutableOptions change.
     * @return {[type]} [description]
     */
    mutableOptions: function mutableOptions() {
      if (!this.taggable && this.resetOnOptionsChange) {
        this.mutableValue = this.multiple ? [] : null;
      }
    },


    /**
    * Always reset the mutableValue when
     * the multiple prop changes.
     * @param  {Boolean} val
     * @return {void}
     */
    multiple: function multiple(val) {
      this.mutableValue = val ? [] : null;
    }
  },

  /**
   * Clone props into mutable values,
   * attach any event listeners.
   */
  created: function created() {
    this.mutableValue = this.value;
    this.mutableOptions = this.options.slice(0);
    this.mutableLoading = this.loading;

    this.$on('option:created', this.maybePushTag);
  },


  methods: {

    /**
     * Select a given option.
     * @param  {Object|String} option
     * @return {void}
     */
    select: function select(option) {
      if (this.isOptionSelected(option)) {
        this.deselect(option);
      } else {
        if (this.taggable && !this.optionExists(option)) {
          option = this.createOption(option);
        }

        if (this.multiple && !this.mutableValue) {
          this.mutableValue = [option];
        } else if (this.multiple) {
          this.mutableValue.push(option);
        } else {
          this.mutableValue = option;
        }
      }

      this.onAfterSelect(option);
    },


    /**
     * De-select a given option.
     * @param  {Object|String} option
     * @return {void}
     */
    deselect: function deselect(option) {
      var _this = this;

      if (this.multiple) {
        var ref = -1;
        this.mutableValue.forEach(function (val) {
          if (val === option || (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object' && val[_this.label] === option[_this.label]) {
            ref = val;
          }
        });
        var index = this.mutableValue.indexOf(ref);
        this.mutableValue.splice(index, 1);
      } else {
        this.mutableValue = null;
      }
    },


    /**
     * Clears the currently selected value(s)
     * @return {void}
     */
    clearSelection: function clearSelection() {
      this.mutableValue = this.multiple ? [] : null;
    },


    /**
     * Called from this.select after each selection.
     * @param  {Object|String} option
     * @return {void}
     */
    onAfterSelect: function onAfterSelect(option) {
      if (this.closeOnSelect) {
        this.open = !this.open;
        this.$refs.search.blur();
      }

      if (this.clearSearchOnSelect) {
        this.search = '';
      }
    },


    /**
     * Toggle the visibility of the dropdown menu.
     * @param  {Event} e
     * @return {void}
     */
    toggleDropdown: function toggleDropdown(e) {
      if (e.target === this.$refs.openIndicator || e.target === this.$refs.search || e.target === this.$refs.toggle || e.target === this.$el) {
        if (this.open) {
          this.$refs.search.blur(); // dropdown will close on blur
        } else {
          if (!this.disabled) {
            this.open = true;
            this.$refs.search.focus();
          }
        }
      }
    },


    /**
     * Check if the given option is currently selected.
     * @param  {Object|String}  option
     * @return {Boolean}        True when selected | False otherwise
     */
    isOptionSelected: function isOptionSelected(option) {
      var _this2 = this;

      if (this.multiple && this.mutableValue) {
        var selected = false;
        this.mutableValue.forEach(function (opt) {
          if ((typeof opt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(opt)) === 'object' && opt[_this2.label] === option[_this2.label]) {
            selected = true;
          } else if ((typeof opt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(opt)) === 'object' && opt[_this2.label] === option) {
            selected = true;
          } else if (opt === option) {
            selected = true;
          }
        });
        return selected;
      }

      return this.mutableValue === option;
    },


    /**
     * If there is any text in the search input, remove it.
     * Otherwise, blur the search input to close the dropdown.
     * @return {void}
     */
    onEscape: function onEscape() {
      if (!this.search.length) {
        this.$refs.search.blur();
      } else {
        this.search = '';
      }
    },


    /**
     * Close the dropdown on blur.
     * @emits  {search:blur}
     * @return {void}
     */
    onSearchBlur: function onSearchBlur() {
      if (this.clearSearchOnBlur) {
        this.search = '';
      }
      this.open = false;
      this.$emit('search:blur');
    },


    /**
     * Open the dropdown on focus.
     * @emits  {search:focus}
     * @return {void}
     */
    onSearchFocus: function onSearchFocus() {
      this.open = true;
      this.$emit('search:focus');
    },


    /**
     * Delete the value on Delete keypress when there is no
     * text in the search input, & there's tags to delete
     * @return {this.value}
     */
    maybeDeleteValue: function maybeDeleteValue() {
      if (!this.$refs.search.value.length && this.mutableValue) {
        return this.multiple ? this.mutableValue.pop() : this.mutableValue = null;
      }
    },


    /**
     * Determine if an option exists
     * within this.mutableOptions array.
     *
     * @param  {Object || String} option
     * @return {boolean}
     */
    optionExists: function optionExists(option) {
      var _this3 = this;

      var exists = false;

      this.mutableOptions.forEach(function (opt) {
        if ((typeof opt === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(opt)) === 'object' && opt[_this3.label] === option) {
          exists = true;
        } else if (opt === option) {
          exists = true;
        }
      });

      return exists;
    },


    /**
     * If push-tags is true, push the
     * given option to mutableOptions.
     *
     * @param  {Object || String} option
     * @return {void}
     */
    maybePushTag: function maybePushTag(option) {
      if (this.pushTags) {
        this.mutableOptions.push(option);
      }
    }
  },

  computed: {

    /**
     * Classes to be output on .dropdown
     * @return {Object}
     */
    dropdownClasses: function dropdownClasses() {
      return {
        open: this.dropdownOpen,
        single: !this.multiple,
        searching: this.searching,
        searchable: this.searchable,
        unsearchable: !this.searchable,
        loading: this.mutableLoading,
        rtl: this.dir === 'rtl',
        disabled: this.disabled
      };
    },


    /**
     * If search text should clear on blur
     * @return {Boolean} True when single and clearSearchOnSelect
     */
    clearSearchOnBlur: function clearSearchOnBlur() {
      return this.clearSearchOnSelect && !this.multiple;
    },


    /**
     * Return the current state of the
     * search input
     * @return {Boolean} True if non empty value
     */
    searching: function searching() {
      return !!this.search;
    },


    /**
     * Return the current state of the
     * dropdown menu.
     * @return {Boolean} True if open
     */
    dropdownOpen: function dropdownOpen() {
      return this.noDrop ? false : this.open && !this.mutableLoading;
    },


    /**
     * Return the placeholder string if it's set
     * & there is no value selected.
     * @return {String} Placeholder text
     */
    searchPlaceholder: function searchPlaceholder() {
      if (this.isValueEmpty && this.placeholder) {
        return this.placeholder;
      }
    },


    /**
     * The currently displayed options, filtered
     * by the search elements value. If tagging
     * true, the search text will be prepended
     * if it doesn't already exist.
     *
     * @return {array}
     */
    filteredOptions: function filteredOptions() {
      var _this4 = this;

      if (!this.filterable && !this.taggable) {
        return this.mutableOptions.slice();
      }
      var options = this.mutableOptions.filter(function (option) {
        if ((typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(option)) === 'object' && option.hasOwnProperty(_this4.label)) {
          return option[_this4.label].toLowerCase().indexOf(_this4.search.toLowerCase()) > -1;
        } else if ((typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(option)) === 'object' && !option.hasOwnProperty(_this4.label)) {
          return console.warn('[vue-select warn]: Label key "option.' + _this4.label + '" does not exist in options object.\nhttp://sagalbot.github.io/vue-select/#ex-labels');
        }
        return option.toLowerCase().indexOf(_this4.search.toLowerCase()) > -1;
      });
      if (this.taggable && this.search.length && !this.optionExists(this.search)) {
        options.unshift(this.search);
      }
      return options;
    },


    /**
     * Check if there aren't any options selected.
     * @return {Boolean}
     */
    isValueEmpty: function isValueEmpty() {
      if (this.mutableValue) {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.mutableValue) === 'object') {
          return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.mutableValue).length;
        }
        return !this.mutableValue.length;
      }

      return true;
    },


    /**
     * Return the current value in array format.
     * @return {Array}
     */
    valueAsArray: function valueAsArray() {
      if (this.multiple) {
        return this.mutableValue;
      } else if (this.mutableValue) {
        return [this.mutableValue];
      }

      return [];
    },


    /**
     * Determines if the clear button should be displayed.
     * @return {Boolean}
     */
    showClearButton: function showClearButton() {
      return !this.multiple && !this.open && this.mutableValue != null;
    }
  }

});

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

/* eslint-disable */
// flow

module.exports = {
  watch: {
    typeAheadPointer: function typeAheadPointer() {
      this.maybeAdjustScroll();
    }
  },

  methods: {
    /**
     * Adjust the scroll position of the dropdown list
     * if the current pointer is outside of the
     * overflow bounds.
     * @returns {*}
     */
    maybeAdjustScroll: function maybeAdjustScroll() {
      var pixelsToPointerTop = this.pixelsToPointerTop();
      var pixelsToPointerBottom = this.pixelsToPointerBottom();

      if (pixelsToPointerTop <= this.viewport().top) {
        return this.scrollTo(pixelsToPointerTop);
      } else if (pixelsToPointerBottom >= this.viewport().bottom) {
        return this.scrollTo(this.viewport().top + this.pointerHeight());
      }
    },


    /**
     * The distance in pixels from the top of the dropdown
     * list to the top of the current pointer element.
     * @returns {number}
     */
    pixelsToPointerTop: function pixelsToPointerTop() {
      var pixelsToPointerTop = 0;
      if (this.$refs.dropdownMenu) {
        for (var i = 0; i < this.typeAheadPointer; i++) {
          pixelsToPointerTop += this.$refs.dropdownMenu.children[i].offsetHeight;
        }
      }
      return pixelsToPointerTop;
    },


    /**
     * The distance in pixels from the top of the dropdown
     * list to the bottom of the current pointer element.
     * @returns {*}
     */
    pixelsToPointerBottom: function pixelsToPointerBottom() {
      return this.pixelsToPointerTop() + this.pointerHeight();
    },


    /**
     * The offsetHeight of the current pointer element.
     * @returns {number}
     */
    pointerHeight: function pointerHeight() {
      var element = this.$refs.dropdownMenu ? this.$refs.dropdownMenu.children[this.typeAheadPointer] : false;
      return element ? element.offsetHeight : 0;
    },


    /**
     * The currently viewable portion of the dropdownMenu.
     * @returns {{top: (string|*|number), bottom: *}}
     */
    viewport: function viewport() {
      return {
        top: this.$refs.dropdownMenu ? this.$refs.dropdownMenu.scrollTop : 0,
        bottom: this.$refs.dropdownMenu ? this.$refs.dropdownMenu.offsetHeight + this.$refs.dropdownMenu.scrollTop : 0
      };
    },


    /**
     * Scroll the dropdownMenu to a given position.
     * @param position
     * @returns {*}
     */
    scrollTo: function scrollTo(position) {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.scrollTop = position : null;
    }
  }
};

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

/* eslint-disable */
module.exports = {
  data: function data() {
    return {
      typeAheadPointer: -1
    };
  },


  watch: {
    filteredOptions: function filteredOptions() {
      this.typeAheadPointer = 0;
    }
  },

  methods: {
    /**
     * Move the typeAheadPointer visually up the list by
     * subtracting the current index by one.
     * @return {void}
     */
    typeAheadUp: function typeAheadUp() {
      if (this.typeAheadPointer > 0) {
        this.typeAheadPointer--;
        if (this.maybeAdjustScroll) {
          this.maybeAdjustScroll();
        }
      }
    },


    /**
     * Move the typeAheadPointer visually down the list by
     * adding the current index by one.
     * @return {void}
     */
    typeAheadDown: function typeAheadDown() {
      if (this.typeAheadPointer < this.filteredOptions.length - 1) {
        this.typeAheadPointer++;
        if (this.maybeAdjustScroll) {
          this.maybeAdjustScroll();
        }
      }
    },


    /**
     * Select the option at the current typeAheadPointer position.
     * Optionally clear the search input on selection.
     * @return {void}
     */
    typeAheadSelect: function typeAheadSelect() {
      if (this.filteredOptions[this.typeAheadPointer]) {
        this.select(this.filteredOptions[this.typeAheadPointer]);
      } else if (this.taggable && this.search.length) {
        this.select(this.search);
      }

      if (this.clearSearchOnSelect) {
        this.search = "";
      }
    }
  }
};

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

/* eslint-disable */
module.exports = {
	props: {
		/**
   * Toggles the adding of a 'loading' class to the main
   * .v-select wrapper. Useful to control UI state when
   * results are being processed through AJAX.
   */
		loading: {
			type: Boolean,
			default: false
		},

		/**
   * Accept a callback function that will be
   * run when the search text changes.
   *
   * loading() accepts a boolean value, and can
   * be used to toggle a loading class from
   * the onSearch callback.
   *
   * @param {search}  String          Current search text
   * @param {loading} Function(bool)  Toggle loading class
   */
		onSearch: {
			type: Function,
			default: function _default(search, loading) {}
		}
	},

	data: function data() {
		return {
			mutableLoading: false
		};
	},


	watch: {
		/**
   * If a callback & search text has been provided,
   * invoke the onSearch callback.
   */
		search: function search() {
			if (this.search.length > 0) {
				this.onSearch(this.search, this.toggleLoading);
				this.$emit('search', this.search, this.toggleLoading);
			}
		},

		/**
  * Sync the loading prop with the internal
  * mutable loading value.
   * @param val
   */
		loading: function loading(val) {
			this.mutableLoading = val;
		}
	},

	methods: {
		/**
   * Toggle this.loading. Optionally pass a boolean
   * value. If no value is provided, this.loading
   * will be set to the opposite of it's current value.
   * @param toggle Boolean
   * @returns {*}
   */
		toggleLoading: function toggleLoading() {
			var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (toggle == null) {
				return this.mutableLoading = !this.mutableLoading;
			}
			return this.mutableLoading = toggle;
		}
	}
};

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_pageExport__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaContainer__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebsiteContainer__ = __webpack_require__(515);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        MediaContainer: __WEBPACK_IMPORTED_MODULE_2__components_MediaContainer__["a" /* default */],
        WebsiteContainer: __WEBPACK_IMPORTED_MODULE_3__components_WebsiteContainer__["a" /* default */]
    },
    data: function data() {
        return {
            excelRunning: false,
            pdfRunning: false
        };
    },

    computed: {
        currentTab: function currentTab() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.currentTab;
        },
        compareOpen: function compareOpen() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.compareChartOpen[__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.currentTab];
        },
        loggedIn: function loggedIn() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.loggedIn;
        }
    },
    methods: {
        exportFilteredPdf: function exportFilteredPdf() {
            var _this = this;

            this.pdfRunning = true;
            __WEBPACK_IMPORTED_MODULE_1__util_pageExport__["a" /* default */].export(this, {
                format: 'pdf',
                type: 'filtered'
            }).then(function () {
                _this.pdfRunning = false;
            });
        },
        exportFilteredExcel: function exportFilteredExcel() {
            var _this2 = this;

            this.excelRunning = true;
            __WEBPACK_IMPORTED_MODULE_1__util_pageExport__["a" /* default */].export(this, {
                format: 'excel',
                type: 'filtered'
            }).then(function () {
                _this2.excelRunning = false;
            });
        }
    }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tiles_MediaTileContainer__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BigChartContainer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PacingTable__ = __webpack_require__(507);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        MediaTileContainer: __WEBPACK_IMPORTED_MODULE_1__components_tiles_MediaTileContainer__["a" /* default */],
        BigChartContainer: __WEBPACK_IMPORTED_MODULE_2__components_BigChartContainer__["a" /* default */],
        PacingTable: __WEBPACK_IMPORTED_MODULE_3__components_PacingTable__["a" /* default */]
    },
    computed: {
        chartData: function chartData() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData;
        },
        pacingData: function pacingData() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.pacingData.data;
        },
        refreshingCharts: function refreshingCharts() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.refreshStatusCharts;
        },
        refreshingPacing: function refreshingPacing() {
            return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.refreshStatusPacing;
        }
    }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tiles_StatTile__ = __webpack_require__(88);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        StatTile: __WEBPACK_IMPORTED_MODULE_1__components_tiles_StatTile__["a" /* default */]
    },
    computed: {
        totalCTRTarget: function totalCTRTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalCTRTarget) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalCTRTarget;
            }

            return 0;
        },
        totalClicksTarget: function totalClicksTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalClicksTarget) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalClicksTarget;
            }

            return 0;
        },
        totalImpressionsTarget: function totalImpressionsTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalImpressionsTarget) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalImpressionsTarget;
            }

            return 0;
        },
        totalVisitsTarget: function totalVisitsTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalVisitsTarget) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalVisitsTarget;
            }

            return 0;
        },
        totalCTRPercent: function totalCTRPercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalCTRPercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalCTRPercent;
            }

            return 0;
        },
        totalClicksPercent: function totalClicksPercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalClicksPercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalClicksPercent;
            }

            return 0;
        },
        totalImpressionsPercent: function totalImpressionsPercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalImpressionsPercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalImpressionsPercent;
            }

            return 0;
        },
        totalVisitsPercent: function totalVisitsPercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalVisitsPercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalVisitsPercent;
            }

            return 0;
        },
        averageTimePercent: function averageTimePercent() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.averageTimePercent) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.averageTimePercent;
            }

            return 0;
        },
        totalCTR: function totalCTR() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalCTR) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalCTR;
            }

            return 0;
        },
        totalClicks: function totalClicks() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalClicks) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalClicks;
            }

            return 0;
        },
        totalImpressions: function totalImpressions() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalImpressions) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalImpressions;
            }

            return 0;
        },
        benchmark: function benchmark() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.industryBenchmark) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.industryBenchmark;
            }

            return 0;
        },
        totalVisits: function totalVisits() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalVisits) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.totalVisits;
            }

            return 0;
        },
        averageTime: function averageTime() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.averageTime) {
                var time = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.averageTime;

                var hours = time.h;
                var minutes = time.m;
                var seconds = time.s;

                return {
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
            }

            return {
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        },
        averageTimeTarget: function averageTimeTarget() {
            if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.averageTimeTarget) {
                var time = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.chartData.averageTimeTarget;

                var hours = time.h;
                var minutes = time.m;
                var seconds = time.s;

                return {
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
            }

            return {
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }
    }
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatTile_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5fbc28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatTile_vue__ = __webpack_require__(445);
function injectStyle (ssrContext) {
  __webpack_require__(443)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c5fbc28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatTile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5fbc28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['mobileText', 'text', 'number', 'secondNumber', 'icon', 'time', 'percent', 'target', 'flip', 'percentage', 'color'],
    data: function data() {
        return {
            tweenedNumber: 0,
            tweenedSecondNumber: 0,
            tweenedHour: 0,
            tweenedMinutes: 0,
            tweenedSeconds: 0,
            tweenedPercent: 0,
            leftClicked: false,
            rightClicked: false,
            animationDuration: 1.8
        };
    },

    methods: {
        clickLeft: function clickLeft() {
            this.rightClicked = false;

            if (this.leftClicked) {
                this.leftClicked = false;
            } else {
                this.leftClicked = true;
            }
        },
        clickRight: function clickRight() {
            this.leftClicked = false;

            if (this.rightClicked) {
                this.rightClicked = false;
            } else {
                this.rightClicked = true;
            }
        }
    },
    computed: {
        targetFormatted: function targetFormatted() {
            return this.target.toLocaleString('en-GB', { useGrouping: true });
        },
        targetHours: function targetHours() {
            return this.target.hours.toLocaleString('en-GB', { minimumIntegerDigits: 2, maximumFractionDigits: 0 });
        },
        targetMinutes: function targetMinutes() {
            return this.target.minutes.toLocaleString('en-GB', { minimumIntegerDigits: 2, maximumFractionDigits: 0 });
        },
        targetSeconds: function targetSeconds() {
            return this.target.seconds.toLocaleString('en-GB', { minimumIntegerDigits: 2, maximumFractionDigits: 0 });
        },
        animatedNumber: function animatedNumber() {
            var format = {
                useGrouping: true,
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            };

            if (this.number >= 1) {
                format.maximumFractionDigits = 0;
                format.minimumFractionDigits = 0;
            }

            return this.tweenedNumber.toLocaleString('en-GB', format);
        },
        animatedSecondNumber: function animatedSecondNumber() {
            var format = {
                useGrouping: true,
                maximumFractionDigits: 2
            };

            if (this.secondNumber >= 1) {
                format.maximumFractionDigits = 0;
            }

            return this.tweenedSecondNumber.toLocaleString('en-GB', format);
        },
        animatedHour: function animatedHour() {
            return this.tweenedHour.toLocaleString('en-GB', { minimumIntegerDigits: 2, maximumFractionDigits: 0 });
        },
        animatedMinutes: function animatedMinutes() {
            return this.tweenedMinutes.toLocaleString('en-GB', { minimumIntegerDigits: 2, maximumFractionDigits: 0 });
        },
        animatedSeconds: function animatedSeconds() {
            return this.tweenedSeconds.toLocaleString('en-GB', { minimumIntegerDigits: 2, maximumFractionDigits: 0 });
        },
        animatedPercent: function animatedPercent() {
            return this.tweenedPercent.toFixed(0);
        },
        animatedWidth: function animatedWidth() {
            return this.tweenedPercent.toFixed(3);
        }
    },
    watch: {
        number: function number(newValue) {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(this.$data, this.animationDuration, {
                tweenedNumber: newValue,
                ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut
            });
        },
        secondNumber: function secondNumber(newValue) {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(this.$data, this.animationDuration, {
                tweenedSecondNumber: newValue,
                ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut
            });
        },
        time: function time(newValue) {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(this.$data, this.animationDuration, {
                tweenedHour: newValue.hours,
                tweenedMinutes: newValue.minutes,
                tweenedSeconds: newValue.seconds,
                ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut
            });
        },
        percent: function percent(newValue) {
            var cappedValue = newValue > 100 ? 100 : newValue;

            __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(this.$data, this.animationDuration, {
                tweenedPercent: cappedValue,
                ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut
            });
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(this.$data, this.animationDuration, {
            tweenedNumber: this.number,
            ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut
        });

        if (this.secondNumber) {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(this.$data, this.animationDuration, {
                tweenedSecondNumber: this.secondNumber,
                ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut
            });
        }

        if (this.time) {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(this.$data, this.animationDuration, {
                tweenedHour: this.time.hours,
                tweenedMinutes: this.time.minutes,
                tweenedSeconds: this.time.seconds,
                ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut
            });
        }

        var cappedValue = this.percent > 100 ? 100 : this.percent;

        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(this.$data, this.animationDuration, {
            tweenedPercent: cappedValue,
            ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut
        });
    }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BigChartContainer_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11668226_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BigChartContainer_vue__ = __webpack_require__(506);
function injectStyle (ssrContext) {
  __webpack_require__(447)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11668226"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BigChartContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11668226_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BigChartContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ToggleChartContainer__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ToggleChartContainer: __WEBPACK_IMPORTED_MODULE_0__components_ToggleChartContainer__["a" /* default */]
    },
    computed: {
        chartDataExists: function chartDataExists() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.chartData.data.length;
        },
        compareOpen: function compareOpen() {
            return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.compareChartOpen[__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.currentTab];
        }
    },
    methods: {
        openComparison: function openComparison() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('openCompare', { tab: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.currentTab });
        },
        closeComparison: function closeComparison() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('closeCompare', { tab: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.currentTab });
        }
    }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tiles_LineChart__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tiles_TableChart__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_filters_SelectInput__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LineChart: __WEBPACK_IMPORTED_MODULE_3__components_tiles_LineChart__["a" /* default */],
        TableChart: __WEBPACK_IMPORTED_MODULE_4__components_tiles_TableChart__["a" /* default */],
        SelectInput: __WEBPACK_IMPORTED_MODULE_5__components_filters_SelectInput__["a" /* default */]
    },
    props: {
        updateFilters: {
            default: false,
            type: Boolean
        }
    },
    data: function data() {
        return {
            showTable: false,
            unselectedXAxis: false,
            uniqueCategories: [],
            uniqueCategoryValues: {},
            series: [],
            filters: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.chartFilters),
            views: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.chartViews),
            dateGroupList: []
        };
    },

    methods: {
        reset: function reset() {
            var _this = this;

            this.uniqueCategories.forEach(function (name) {
                if (_this.updateFilters) {
                    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('updateChartFilters', {
                        name: name, value: null
                    });
                }

                _this.$set(_this.filters, name, null);
            });

            this.$set(this.views, 'Series', null);
            this.$set(this.views, 'XValue', 'Date');
            this.$set(this.views, 'dateGroup', 'Days');
        },
        toChart: function toChart() {
            this.showTable = false;
        },
        toTable: function toTable() {
            this.showTable = true;
        },
        filterUpdate: function filterUpdate(name, value) {
            this.filters[name] = value;

            if (this.updateFilters) {
                __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('updateChartFilters', {
                    name: name, value: value
                });
            }

            if (name === 'Date' && value !== null) {
                if (this.views.XValue === 'Date') {
                    this.viewsUpdate('XValue', null);
                }
            }

            this.createCategories();
        },
        viewsUpdate: function viewsUpdate(name, value) {
            if (name === 'XValue' && value === null) {
                this.unselectedXAxis = true;
            } else if (name === 'XValue') {
                this.unselectedXAxis = false;
            }

            this.views[name] = value;

            if (this.updateFilters) {
                __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('updateChartViews', {
                    name: name, value: value
                });
            }

            this.createCategories();
        },
        createCategories: function createCategories() {
            var _this2 = this;

            this.dateGroupList = [];
            this.uniqueCategoryValues = [];

            var uniqueDays = [];
            var uniqueWeeks = [];
            var uniqueMonths = [];

            // let test = 0;
            this.jsonData.forEach(function (datum) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datum.categories).forEach(function (category) {
                    var categoryObject = datum.categories[category];
                    // test += 1;
                    if (category === 'Date') {
                        var date = categoryObject;
                        var week = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('W YYYY');
                        var month = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, 'YYYY-MM-DD').format('MMMM YYYY');

                        if (!uniqueDays.includes(date)) {
                            uniqueDays.push(date);
                        }

                        if (!uniqueWeeks.includes(week)) {
                            uniqueWeeks.push(week);
                        }

                        if (!uniqueMonths.includes(month)) {
                            uniqueMonths.push(month);
                        }
                    }

                    if (!_this2.uniqueCategories.includes(category)) {
                        _this2.uniqueCategories.push(category);
                    }

                    var changedCategory = categoryObject;

                    if (category === 'Date') {
                        if (_this2.views.dateGroup === 'Weeks') {
                            changedCategory = __WEBPACK_IMPORTED_MODULE_2_moment___default()(changedCategory, 'YYYY-MM-DD').format('W YYYY');
                        } else if (_this2.views.dateGroup === 'Months') {
                            changedCategory = __WEBPACK_IMPORTED_MODULE_2_moment___default()(changedCategory, 'YYYY-MM-DD').format('MMMM YYYY');
                        }
                    }

                    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.uniqueCategoryValues).includes(category)) {
                        _this2.uniqueCategoryValues[category] = [];
                        // eslint-disable-next-line
                    } else if (!_this2.uniqueCategoryValues[category].includes(changedCategory)) {
                        if (category === 'Creative' && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.chartFilters.Placement) {
                            if (datum.categories.Placement === __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.chartFilters.Placement) {
                                // eslint-disable-next-line
                                _this2.uniqueCategoryValues[category].push(changedCategory);
                            }
                        } else {
                            _this2.uniqueCategoryValues[category].push(changedCategory);
                        }
                    }
                });

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datum.values).forEach(function (value) {
                    if (!_this2.series.includes(value)) {
                        _this2.series.push(value);
                    }
                });
            });

            this.dateGroupList.push('Days');

            if (uniqueWeeks.length > 1) {
                this.dateGroupList.push('Weeks');
            }

            if (uniqueMonths.length > 1) {
                this.dateGroupList.push('Months');
            }

            if (!this.series.includes('CTR %')) {
                this.series.push('CTR %');
            }

            this.uniqueCategories.forEach(function (cat) {
                if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.filters).includes(cat)) {
                    var cateName = '' + cat;
                    _this2.$set(_this2.filters, cateName, null);
                }
            });
        }
    },
    computed: {
        jsonData: function jsonData() {
            return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.chartData.data;
        },
        compareOpen: function compareOpen() {
            return __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.compareChartOpen[__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.currentTab];
        }
    },
    mounted: function mounted() {
        this.createCategories();
    }
});

/***/ })

},[355]);


// WEBPACK FOOTER //
// static/js/app.e10e3af87f8dea92d3af.js